import { all, put, takeEvery, call } from 'redux-saga/effects';
import axios from 'axios';
// import { useDispatch, useSelector } from 'react-redux';

import { CommonConfig } from '../../../../config/common-config';

import {
    CreateGenInfoActionTypes,
    // CreateBankDetailsActionTypes,
    // GetGenInfoActionTypes,
    CreateGenInfoRequestSubmitActionTypes,
} from '../actionsTypes';

// const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
// const user_token = tempToken && tempToken.data.token;
//console.log('ravi-token', user_token);
// const bearerToken = `Bearer ${user_token}`;

function* handleGenInfoRequestSave(action) {
    try {
        const { params, bearerToken, serviceIdValue, usertype, statusIDValue, tennantnameValue, imcNameSelected } = action.payload;
        console.log('SAVE =>>>>> params', params);
        const values = params;
        const userType = usertype;
        const statusid = statusIDValue;
        console.log('values==----->saga', values);
        //console.log('statusIDValue==----->saga', statusIDValue);
        //console.log('serviceIdValue==----->saga', serviceIdValue);

        //console.log('investment1==----->saga', values.investment1);
        //console.log('usertype==----->saga', userType);
        //console.log('statusid==----->saga', statusid);
        //console.log('tennantnameValue', tennantnameValue);
        //console.log('imcNameSelected', imcNameSelected);

        //console.log('Bank Details From Saga1', values.bankDetails);

        const data = {
            serviceId: serviceIdValue,
            remarks: 'Remarks',
            checklistJson: {
                checklistL1: {
                    relevantFlag: false,
                    questions: [
                        {
                            sectionText: 'General Information?',
                            relevanceResponse: '',
                            relevanceRemarks: '',
                            relevantFlag: false,
                            autoPopulate: true,
                            fields: [
                                {
                                    fieldName: 'firstName',
                                    response: values.firstName,
                                    relevanceResponseCRC: values.firstnameRelevance,
                                    relevanceRemarksCRC: values.firstnameRelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'lastName',
                                    response: values.lastName,
                                    relevanceResponseCRC: values.lastnameRelevance,
                                    relevanceRemarksCRC: values.lastnameRelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'fatherNamePan',
                                    response: values.fatherNamePan,
                                    relevanceResponseCRC: values.fatherNamePanRelevance,
                                    relevanceRemarksCRC: values.fatherNamePanRelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'pan',
                                    response: values.pan,
                                    relevanceResponseCRC: values.panRelevance,
                                    relevanceRemarksCRC: values.panRelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'address1',
                                    response: values.address1,
                                    relevanceResponseCRC: values.address1Relevance,
                                    relevanceRemarksCRC: values.address1RelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'address2',
                                    response: values.address2,
                                    relevanceResponseCRC: values.address2Relevance,
                                    relevanceRemarksCRC: values.address2RelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'city',
                                    response: values.city,
                                    relevanceResponseCRC: values.cityRelevance,
                                    relevanceRemarksCRC: values.cityRelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'state',
                                    response: values.state,
                                    relevanceResponseCRC: values.stateRelevance,
                                    relevanceRemarksCRC: values.stateRelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'country',
                                    response: values.country,
                                    relevanceResponseCRC: values.countryRelevance,
                                    relevanceRemarksCRC: values.countryRelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'pin',
                                    response: values.pin,
                                    relevanceResponseCRC: values.pinRelevance,
                                    relevanceRemarksCRC: values.pinRelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'dob',
                                    response: values.dob,
                                    relevanceResponseCRC: values.dobRelevance,
                                    relevanceRemarksCRC: values.dobRelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'mobileNo',
                                    response: values.mobileNo,
                                    relevanceResponseCRC: values.mobileNoRelevance,
                                    relevanceRemarksCRC: values.mobileNoRelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'emailaddress',
                                    response: values.emailaddress,
                                    relevanceResponseCRC: values.emailaddressRelevance,
                                    relevanceRemarksCRC: values.emailaddressRelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'passport',
                                    response: values.passport,
                                    relevanceResponseCRC: values.passportRelevance,
                                    relevanceRemarksCRC: values.passportRelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'govIDType',
                                    response: values.govIDType,
                                    relevanceResponseCRC: values.govIDTypeRelevance,
                                    relevanceRemarksCRC: values.govIDTypeRelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'govIDNumber',
                                    response: values.govIDNumber,
                                    relevanceResponseCRC: values.govIDNumberRelevance,
                                    relevanceRemarksCRC: values.govIDNumberRelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'Upload',
                                    response: values.URLValue,
                                    relevanceResponseCRC: values.URLValueRelevance,
                                    relevanceRemarksCRC: values.URLValueRelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'radiodata',
                                    response: values.radiodata,
                                    relevanceResponseCRC: values.radioDataRelevance,
                                    relevanceRemarksCRC: values.radioDataRelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'GSTIN',
                                    response: values.GSTIN,
                                    relevanceResponseCRC: values.gstinRelevance,
                                    relevanceRemarksCRC: values.gstinRelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'panFile',
                                    response: values.panFile,
                                    relevanceResponseCRC: '',
                                    relevanceRemarksCRC: '',
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'aadharFile',
                                    response: values.aadharFile,
                                    relevanceResponseCRC: '',
                                    relevanceRemarksCRC: '',
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'enrollmentFile',
                                    response: values.enrollmentFile,
                                    relevanceResponseCRC: '',
                                    relevanceRemarksCRC: '',
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'gstFile',
                                    response: values.gstFile,
                                    relevanceResponseCRC: '',
                                    relevanceRemarksCRC: '',
                                    autoPopulate: true,
                                },
                            ],
                        },
                        {
                            sectionText: 'Bank Details',
                            relevanceResponse: '',
                            relevanceRemarks: '',
                            relevantFlag: false,
                            autoPopulate: true,
                            fields: [],
                        },
                        {
                            sectionText: 'What are the different sources of income that you have?',
                            relevanceResponseCRC: 'Relevant',
                            relevanceRemarksCRC: '',
                            relevanceResponseAM: 'Relevant',
                            relevanceRemarksAM: '',
                            relevantFlag: false,
                            autoPopulate: true,
                            subQuestion: [
                                {
                                    sectionText: 'Salary',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    subSubQuestions: [
                                        {
                                            sectionText: 'SalaryTab',
                                            response: '',
                                            relevanceResponseCRC: 'Relevant',
                                            relevanceRemarksCRC: '',
                                            relevanceResponseAM: 'Relevant',
                                            relevanceRemarksAM: '',
                                            fields: [
                                                // {

                                                //     fieldName: 'Do you have income from salary/pension?',
                                                //     response: '',
                                                //     relevanceResponseCRC: 'Relevant',
                                                //     relevanceRemarksCRC: '',
                                                //     relevanceResponseAM: 'Relevant',
                                                //     relevanceRemarksAM: '',
                                                //     autoPopulate: true,
                                                // },
                                                {
                                                    fieldName: 'salaryradiodata',
                                                    response: values.salaryradiodata,
                                                    relevanceResponseCRC: 'Relevant',
                                                    relevanceRemarksCRC: '',
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                    autoPopulate: true,
                                                },
                                                {
                                                    fieldName: 'Name of the Employer',
                                                    response: values.nameEmployer,
                                                    relevanceResponseCRC: values.nameEmployerCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.nameEmployerCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                    autoPopulate: true,
                                                },
                                                {
                                                    fieldName: 'Upload Form16',
                                                    response: values.url,
                                                    relevanceResponseCRC: values.nameEmployerCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.nameEmployerCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                    autoPopulate: true,
                                                },
                                            ],
                                        },
                                        {
                                            sectionText: 'investment',
                                            response: '',
                                            relevanceResponseCRC: 'Relevant',
                                            relevanceRemarksCRC: '',
                                            relevanceResponseAM: 'Relevant',
                                            relevanceRemarksAM: '',
                                            fields: [],
                                        },
                                        {
                                            sectionText: 'donation',
                                            response: '',
                                            relevanceResponseCRC: 'Relevant',
                                            relevanceRemarksCRC: '',
                                            relevanceResponseAM: 'Relevant',
                                            relevanceRemarksAM: '',
                                            fields: [],
                                        },
                                    ],
                                },
                                {
                                    sectionText: 'House Property',
                                    response: values.incomeFromHouseProperty,
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                    subSubQuestions: [],
                                },
                                {
                                    sectionText: 'Business or Profession',
                                    response: values.incomeFromBusinessProfesion,
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    subSubQuestions: [
                                        {
                                            sectionText: 'BusinessTab',
                                            response: '',
                                            relevanceResponseCRC: 'Relevant',
                                            relevanceRemarksCRC: '',
                                            relevanceResponseAM: 'Relevant',
                                            relevanceRemarksAM: '',
                                            fields: [
                                                {
                                                    fieldName: 'natureBusiness',
                                                    response: values.natureBusiness,
                                                    relevanceResponseCRC: values.natureBusinessCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.natureBusinessCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                    autoPopulate: true,
                                                },
                                                {
                                                    fieldName: 'busProfincomeType',
                                                    response: values.busProfincomeType,
                                                    relevanceResponseCRC: values.busProfincomeTypeCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.busProfincomeTypeCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'totalReceipts',
                                                    response: values.totalReceipts,
                                                    relevanceResponseCRC: values.totalReceiptsCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.totalReceiptsCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'totalExpenses',
                                                    response: values.totalExpenses,
                                                    relevanceResponseCRC: values.totalExpensesCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.totalExpensesCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'gstReturnDoc',
                                                    response: values.gstReturnDoc,
                                                    relevanceResponseCRC: values.gstReturnDocCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.gstReturnDocCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'otherStatement',
                                                    response: values.otherStatement,
                                                    relevanceResponseCRC: values.otherStatementCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.otherStatementCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'busProfType',
                                                    response: values.busProfType,
                                                    relevanceResponseCRC: values.busProfTypeCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.busProfTypeCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'userIDtally',
                                                    response: values.userIDtally,
                                                    relevanceResponseCRC: values.userIDtallyCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.userIDtallyCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'passwordtally',
                                                    response: values.passwordtally,
                                                    relevanceResponseCRC: values.passwordtallyCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.passwordtallyCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'uploadTally',
                                                    response: values.uploadTally,
                                                    relevanceResponseCRC: values.uploadTallyCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.uploadTallyCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'userIDZoho',
                                                    response: values.userIDZoho,
                                                    relevanceResponseCRC: values.userIDZohoCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.userIDZohoCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'passwordZoho',
                                                    response: values.passwordZoho,
                                                    relevanceResponseCRC: values.passwordZohoCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.passwordZohoCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'accountDetails',
                                                    response: values.accountDetails,
                                                    relevanceResponseCRC: values.accountDetailsCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.accountDetailsCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'partnershipradio',
                                                    response: values.partnershipradio,
                                                    relevanceResponseCRC: values.partnershipradioCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.partnershipradioCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'totalReceiptsUpload',
                                                    response: values.totalReceiptsUpload,
                                                    relevanceResponseCRC: values.totalReceiptsUploadCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.totalReceiptsUploadCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'totalExpensesUpload',
                                                    response: values.totalExpensesUpload,
                                                    relevanceResponseCRC: values.totalExpensesUploadCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.totalExpensesUploadCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'gstUpload',
                                                    response: values.gstUpload,
                                                    relevanceResponseCRC: values.gstUploadCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.gstUploadCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'statementUpload',
                                                    response: values.statementUpload,
                                                    relevanceResponseCRC: values.statementUploadCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.statementUploadCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'userIDQB',
                                                    response: values.userIDQB,
                                                    relevanceResponseCRC: values.userIDQBCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.userIDQBCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'passwordQB',
                                                    response: values.passwordQB,
                                                    relevanceResponseCRC: values.passwordQBCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.passwordQBCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                            ],
                                        },
                                        {
                                            sectionText: 'TallyYes',
                                            response: '',
                                            relevanceResponseCRC: 'Relevant',
                                            relevanceRemarksCRC: '',
                                            relevanceResponseAM: 'Relevant',
                                            relevanceRemarksAM: '',
                                            fields: [],
                                        },
                                    ],
                                },
                                {
                                    sectionText: 'Capital Gain',
                                    response: values.soldAnyAsset,
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                },
                                {
                                    sectionText: 'Others Sources',
                                    response: values.explicitlyUncoveredIncom,
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    subSubQuestions: [
                                        {
                                            fieldName: 'divident',
                                            response: '',
                                            relevanceResponseCRC: 'Relevant',
                                            relevanceRemarksCRC: '',
                                            relevanceResponseAM: 'Relevant',
                                            relevanceRemarksAM: '',
                                            fields: [],
                                        },
                                        {
                                            fieldName: 'fd',
                                            response: '',
                                            relevanceResponseCRC: 'Relevant',
                                            relevanceRemarksCRC: '',
                                            relevanceResponseAM: 'Relevant',
                                            relevanceRemarksAM: '',
                                            fields: [],
                                        },
                                        {
                                            fieldName: 'othersources',
                                            response: '',
                                            relevanceResponseCRC: 'Relevant',
                                            relevanceRemarksCRC: '',
                                            relevanceResponseAM: 'Relevant',
                                            relevanceRemarksAM: '',
                                            fields: [],
                                        },
                                    ],
                                },
                                {
                                    sectionText: 'Agriculture Income',
                                    response: values.agricultureIncome,
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                    //     {
                                    //         fieldName: 'agricultureName',
                                    //         response: values.agricultureName,
                                    //         relevanceResponseCRC: values.agricultureNameCRCrelevenceResponse,
                                    //         relevanceRemarksCRC: values.agricultureNameCRCrelevenceRemarks,
                                    //         relevanceResponseAM: 'Relevant',
                                    //         relevanceRemarksAM: '',
                                    //     },
                                    //     {
                                    //         fieldName: 'agriAmount',
                                    //         response: values.agriAmount,
                                    //         relevanceResponseCRC: values.agriAmountCRCrelevenceResponse,
                                    //         relevanceRemarksCRC: values.agriAmountCRCrelevenceRemarks,
                                    //         relevanceResponseAM: 'Relevant',
                                    //         relevanceRemarksAM: '',
                                    //     },
                                    //     {
                                    //         fieldName: 'agriReceipt',
                                    //         response: values.agriReceipt,
                                    //         relevanceResponseCRC: values.agriReceiptCRCrelevenceResponse,
                                    //         relevanceRemarksCRC: values.agriReceiptCRCrelevenceRemarks,
                                    //         relevanceResponseAM: 'Relevant',
                                    //         relevanceRemarksAM: '',
                                    //     },
                                    //     {
                                    //         fieldName: 'agriExpenses',
                                    //         response: values.agriExpenses,
                                    //         relevanceResponseCRC: values.agriExpensesCRCrelevenceResponse,
                                    //         relevanceRemarksCRC: values.agriExpensesCRCrelevenceRemarks,
                                    //         relevanceResponseAM: 'Relevant',
                                    //         relevanceRemarksAM: '',
                                    //     },
                                    //     {
                                    //         fieldName: 'agriReceiptUpload',
                                    //         response: values.agriReceiptUpload,
                                    //         relevanceResponseCRC: values.agriReceiptUploadCRCrelevenceResponse,
                                    //         relevanceRemarksCRC: values.agriReceiptUploadCRCrelevenceRemarks,
                                    //         relevanceResponseAM: 'Relevant',
                                    //         relevanceRemarksAM: '',
                                    //     },
                                    //     {
                                    //         fieldName: 'agriExpensesUpload',
                                    //         response: values.agriExpensesUpload,
                                    //         relevanceResponseCRC: values.agriExpensesUploadCRCrelevenceResponse,
                                    //         relevanceRemarksCRC: values.agriExpensesUploadCRCrelevenceRemarks,
                                    //         relevanceResponseAM: 'Relevant',
                                    //         relevanceRemarksAM: '',
                                    //     },
                                    // ],
                                },
                                {
                                    sectionText: 'Deductions',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    subSubQuestions: [
                                        {
                                            sectionText: 'investment1',
                                            response: '',
                                            relevanceResponseCRC: 'Relevant',
                                            relevanceRemarksCRC: '',
                                            relevanceResponseAM: 'Relevant',
                                            relevanceRemarksAM: '',
                                            fields: [],
                                        },
                                        {
                                            sectionText: 'donation1',
                                            response: '',
                                            relevanceResponseCRC: 'Relevant',
                                            relevanceRemarksCRC: '',
                                            relevanceResponseAM: 'Relevant',
                                            relevanceRemarksAM: '',
                                            fields: [],
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            sectionText: 'Income tax login password',
                            relevanceResponse: '',
                            relevanceRemarks: '',
                            relevantFlag: false,
                            autoPopulate: true,
                            fields: [
                                {
                                    fieldName: 'incomeTaxType',
                                    response: values.incomeTaxType,
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'User ID',
                                    response: values.incomeUserId,
                                    relevanceResponseCRC: values.userIdRelevance,
                                    relevanceRemarksCRC: values.userIdRelevanceRemarks,
                                },
                                {
                                    fieldName: 'Password',
                                    response: values.incomePassword,
                                    relevanceResponseCRC: values.passwordRelevance,
                                    relevanceRemarksCRC: values.passwordRelevanceRemarks,
                                },
                            ],
                        },
                        {
                            sectionText: 'Have you travelled outside india during the previous year?',
                            relevanceResponse: '',
                            relevanceRemarks: '',
                            relevantFlag: false,
                            autoPopulate: true,
                            fields: [
                                {
                                    fieldName: 'traveloutsideType',
                                    response: values.traveloutsideType,
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    autoPopulate: true,
                                },
                            ],
                            subQuestion: [
                                {
                                    sectionText: 'traveloutside',
                                    relevanceResponse: '',
                                    relevanceRemarks: '',
                                    relevantFlag: false,
                                    autoPopulate: true,
                                    fields: [],
                                },
                            ],
                        },
                        {
                            sectionText: 'Directory Company?',
                            relevanceResponse: '',
                            relevanceRemarks: '',
                            relevantFlag: false,
                            autoPopulate: true,
                            fields: [
                                {
                                    fieldName: 'directorType',
                                    response: values.directorType,
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    autoPopulate: true,
                                },
                            ],
                            subQuestion: [
                                {
                                    sectionText: 'directorCompany',
                                    relevanceResponse: '',
                                    relevanceRemarks: '',
                                    relevantFlag: false,
                                    autoPopulate: true,
                                    fields: [],
                                },
                            ],
                        },
                        {
                            sectionText: 'Do you have income/assets from sources outside india?',
                            relevanceResponse: '',
                            relevanceRemarks: '',
                            relevantFlag: false,
                            autoPopulate: true,
                            subQuestion: [
                                {
                                    sectionText: 'Details of Income accuring or arising outside India',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    subSubQuestions: [
                                        {
                                            sectionText: 'assetHome',
                                            response: '',
                                            relevanceResponseCRC: 'Relevant',
                                            relevanceRemarksCRC: '',
                                            relevanceResponseAM: 'Relevant',
                                            relevanceRemarksAM: '',
                                            fields: [],
                                        },
                                        {
                                            sectionText: 'assetNature',
                                            response: '',
                                            relevanceResponseCRC: 'Relevant',
                                            relevanceRemarksCRC: '',
                                            relevanceResponseAM: 'Relevant',
                                            relevanceRemarksAM: '',
                                            fields: [],
                                        },
                                    ],
                                },
                                {
                                    sectionText: 'Details of financial interest in any entity',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                },
                                {
                                    sectionText: 'Details of immovable property',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                },
                                {
                                    sectionText: 'Details of any others capital asset held at any time during the previous year',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                },
                                {
                                    sectionText:
                                        'Details of accounts in which you are a signing authority, which is not part of any of above list',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                },
                                {
                                    sectionText: 'Details of Trust created outside India, in which you are a trustee ',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                },
                                {
                                    sectionText:
                                        'Details of any other income derived from any other source outside India which is not included above',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                },
                                {
                                    sectionText:
                                        'Details of foreign depository accounts held (including any beneficial interest) at any time during the year',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                },
                                {
                                    sectionText:
                                        'Details of foreign custodial accounts held (including any beneficial interest) at any time during the year',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                },
                                {
                                    sectionText:
                                        'Details of foreign equity and debt interest held (including any beneficial interest) in any entity at any time during the year',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                },
                                {
                                    sectionText:
                                        'Details of foreign cash value insurance contract or annuity contract held (including any beneficial interest) at any time during the year',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                },
                                {
                                    sectionText: 'Foreign Asset Radio',
                                    relevanceResponse: '',
                                    relevanceRemarks: '',
                                    relevantFlag: false,
                                    autoPopulate: true,
                                    fields: [
                                        {
                                            fieldName: 'assetradio',
                                            response: values.assetradio,
                                            relevanceResponseCRC: 'Relevant',
                                            relevanceRemarksCRC: '',
                                            relevanceResponseAM: 'Relevant',
                                            relevanceRemarksAM: '',
                                            autoPopulate: true,
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            sectionText: 'Does your total income exceed Rs 50Lakhs?',
                            relevanceResponse: '',
                            relevanceRemarks: '',
                            relevantFlag: false,
                            autoPopulate: true,
                            subQuestion: [
                                {
                                    sectionText: 'Details of immovable assets',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                },
                                {
                                    sectionText: 'Details of movable seat',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                },
                                {
                                    sectionText: 'Whether you have held unlisted equity shares at any time during the previous year',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                },
                                {
                                    sectionText:
                                        'Interest held in the assets of a firm or association of persons (AOP) as a partner or member thereof',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                },
                                {
                                    sectionText: 'Liabilities(if any) relating to the above assets at A,B and C',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                },
                                {
                                    sectionText: 'Total income Radio',
                                    relevanceResponse: '',
                                    relevanceRemarks: '',
                                    relevantFlag: false,
                                    autoPopulate: true,
                                    fields: [
                                        {
                                            fieldName: 'totalincomeradio',
                                            response: values.totalincomeradio,
                                            relevanceResponseCRC: 'Relevant',
                                            relevanceRemarksCRC: '',
                                            relevanceResponseAM: 'Relevant',
                                            relevanceRemarksAM: '',
                                            autoPopulate: true,
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            sectionText: 'additionalQuestion',
                            relevanceResponse: '',
                            relevanceRemarks: '',
                            relevantFlag: false,
                            autoPopulate: true,
                            subQuestion: [
                                {
                                    sectionText: 'additionalQuestion',
                                    response: '',
                                    isAttachmentRequired: true,
                                    relevantFlag: true,
                                    autoPopulate: true,
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                },
                            ],
                        },
                    ],
                },
            },
        };

        if (values.additionalQue !== null && values.additionalQue !== undefined) {
            values.additionalQue.map((value, index) => {
                // console.log('additionalQue.....', value);
                let additionalQueArr = {};
                if (value !== null) {
                    additionalQueArr = {
                        fieldName: 'response',
                        response: value.response,
                        relevanceRemarksAM: value.questionId,
                        relevanceResponseAM: value.questionText,
                        relevanceRemarksCRC: value.relevanceRemarksCRC,
                        relevanceResponseCRC: value.relevanceResponseCRC,
                    };
                    data.checklistJson.checklistL1.questions[8].subQuestion[0].fields.push(additionalQueArr);
                }
                return true;
            });
        }

        // if (values.additionalQue !== null && values.additionalQue !== undefined) {
        //     values.additionalQue.map((value, index) => {
        //         ////console.log('value.....', value);
        //         let additionalQueArr = {};
        //         if (value !== null) {
        //             additionalQueArr = {
        //                 fieldName: 'response',
        //                 response: value.response,
        //                 relevanceRemarksAM: value.questionId,
        //                 relevanceResponseAM: value.questionText,
        //                 relevanceRemarksCRC: value.relevanceRemarksCRC,
        //                 relevanceResponseCRC: value.relevanceResponseCRC,
        //             };
        //             data.checklistJson.checklistL1.questions[8].subQuestion[0].fields.push(additionalQueArr);
        //         }
        //         return true;
        //     });
        // }

        if (values.travelOutside !== null && values.travelOutside !== undefined) {
            values.travelOutside.map((value, index) => {
                //console.log('index.....', index);
                let travelOutsideArr = {};
                if (value.year !== null) {
                    travelOutsideArr = {
                        fieldName: 'year',
                        response: value.year,
                        relevanceResponseCRC: value.yearRelevance,
                        relevanceRemarksCRC: value.yearRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[4].subQuestion[0].fields.push(travelOutsideArr);
                }

                if (value.daysIndia !== null) {
                    travelOutsideArr = {
                        fieldName: 'daysIndia',
                        response: value.daysIndia,
                        relevanceResponseCRC: value.daysIndiaRelevance,
                        relevanceRemarksCRC: value.daysIndiaRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[4].subQuestion[0].fields.push(travelOutsideArr);
                }

                return true;
            });
        }

        if (values.directorCompany !== null && values.directorCompany !== undefined) {
            values.directorCompany.map((value, index) => {
                //console.log('index.....', index);
                let directorCompanyArr = {};
                if (value.companyName !== null) {
                    directorCompanyArr = {
                        fieldName: 'companyName',
                        response: value.companyName,
                        relevanceResponseCRC: value.companyNameRelevance,
                        relevanceRemarksCRC: value.companyNameRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[5].subQuestion[0].fields.push(directorCompanyArr);
                }

                if (value.panCompany !== null) {
                    directorCompanyArr = {
                        fieldName: 'panCompany',
                        response: value.panCompany,
                        relevanceResponseCRC: value.panCompanyRelevance,
                        relevanceRemarksCRC: value.panCompanyRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[5].subQuestion[0].fields.push(directorCompanyArr);
                }

                if (value.shares !== null) {
                    directorCompanyArr = {
                        fieldName: 'shares',
                        response: value.shares,
                        relevanceResponseCRC: value.sharesRelevance,
                        relevanceRemarksCRC: value.sharesRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[5].subQuestion[0].fields.push(directorCompanyArr);
                }

                if (value.din !== null) {
                    directorCompanyArr = {
                        fieldName: 'din',
                        response: value.din,
                        relevanceResponseCRC: value.compDinRelevance,
                        relevanceRemarksCRC: value.compDinRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[5].subQuestion[0].fields.push(directorCompanyArr);
                }

                return true;
            });
        }

        if (values.assetHome !== null && values.assetHome !== undefined) {
            values.assetHome.map((value, index) => {
                //console.log('index.....', index);
                let assetHomeArr = {};
                if (value.country !== null) {
                    assetHomeArr = {
                        fieldName: 'country',
                        response: value.country,
                        relevanceResponseCRC: value.country1Relevance,
                        relevanceRemarksCRC: value.country1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[0].subSubQuestions[0].fields.push(assetHomeArr);
                }

                if (value.tpin !== null) {
                    assetHomeArr = {
                        fieldName: 'tpin',
                        response: value.tpin,
                        relevanceResponseCRC: value.tpinRelevance,
                        relevanceRemarksCRC: value.tpinRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[0].subSubQuestions[0].fields.push(assetHomeArr);
                }

                if (value.salA !== null) {
                    assetHomeArr = {
                        fieldName: 'salA',
                        response: value.salA,
                        relevanceResponseCRC: value.salARelevance,
                        relevanceRemarksCRC: value.salARelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[0].subSubQuestions[0].fields.push(assetHomeArr);
                }

                if (value.salB !== null) {
                    assetHomeArr = {
                        fieldName: 'salB',
                        response: value.salB,
                        relevanceResponseCRC: value.salBRelevance,
                        relevanceRemarksCRC: value.salBRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[0].subSubQuestions[0].fields.push(assetHomeArr);
                }
                if (value.salC !== null) {
                    assetHomeArr = {
                        fieldName: 'salC',
                        response: value.salC,
                        relevanceResponseCRC: value.salCRelevance,
                        relevanceRemarksCRC: value.salCRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[0].subSubQuestions[0].fields.push(assetHomeArr);
                }
                if (value.salD !== null) {
                    assetHomeArr = {
                        fieldName: 'salD',
                        response: value.salD,
                        relevanceResponseCRC: value.salDRelevance,
                        relevanceRemarksCRC: value.salDRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[0].subSubQuestions[0].fields.push(assetHomeArr);
                }
                if (value.salE !== null) {
                    assetHomeArr = {
                        fieldName: 'salE',
                        response: value.salE,
                        relevanceResponseCRC: value.salERelevance,
                        relevanceRemarksCRC: value.salERelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[0].subSubQuestions[0].fields.push(assetHomeArr);
                }
                if (value.srcNature !== null) {
                    assetHomeArr = {
                        fieldName: 'srcNature',
                        response: value.srcNature,
                        relevanceResponseCRC: value.srcNatureRelevance,
                        relevanceRemarksCRC: value.srcNatureRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[0].subSubQuestions[0].fields.push(assetHomeArr);
                }
                if (value.totIncome !== null) {
                    assetHomeArr = {
                        fieldName: 'totIncome',
                        response: value.totIncome,
                        relevanceResponseCRC: value.totIncomeRelevance,
                        relevanceRemarksCRC: value.totIncomeRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[0].subSubQuestions[0].fields.push(assetHomeArr);
                }
                return true;
            });
        }

        if (values.assetNature !== null && values.assetNature !== undefined) {
            values.assetNature.map((value, index) => {
                //console.log('index.....', index);
                let assetNatureArr = {};
                if (value.incomeNature !== null) {
                    assetNatureArr = {
                        fieldName: 'incomeNature',
                        response: value.incomeNature,
                        relevanceResponseCRC: value.incomeNatureRelevance,
                        relevanceRemarksCRC: value.incomeNatureRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[0].subSubQuestions[1].fields.push(assetNatureArr);
                }

                if (value.foreignAmount !== null) {
                    assetNatureArr = {
                        fieldName: 'foreignAmount',
                        response: value.foreignAmount,
                        relevanceResponseCRC: value.foreignAmountRelevance,
                        relevanceRemarksCRC: value.foreignAmountRelevanceRemarks,
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[0].subSubQuestions[1].fields.push(assetNatureArr);
                }

                if (value.foreignTaxes !== null) {
                    assetNatureArr = {
                        fieldName: 'foreignTaxes',
                        response: value.foreignTaxes,
                        relevanceResponseCRC: value.foreignTaxesRelevance,
                        relevanceRemarksCRC: value.foreignTaxesRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[0].subSubQuestions[1].fields.push(assetNatureArr);
                }
                return true;
            });
        }

        if (values.client1 !== null && values.client1 !== undefined) {
            values.client1.map((value, index) => {
                //console.log('index.....', index);
                let client1Arr = {};
                if (value.country !== null) {
                    client1Arr = {
                        fieldName: 'country',
                        response: value.country,
                        relevanceResponseCRC: value.country1Relevance,
                        relevanceRemarksCRC: value.country1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[1].fields.push(client1Arr);
                }

                if (value.entityNature !== null) {
                    client1Arr = {
                        fieldName: 'entityNature',
                        response: value.entityNature,
                        relevanceResponseCRC: value.entityNature1Relevance,
                        relevanceRemarksCRC: value.entityNature1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[1].fields.push(client1Arr);
                }

                if (value.entityName !== null) {
                    client1Arr = {
                        fieldName: 'entityName',
                        response: value.entityName,
                        relevanceResponseCRC: value.entityName1Relevance,
                        relevanceRemarksCRC: value.entityName1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[1].fields.push(client1Arr);
                }
                if (value.entityAddress !== null) {
                    client1Arr = {
                        fieldName: 'entityAddress',
                        response: value.entityAddress,
                        relevanceResponseCRC: value.entityAddress1Relevance,
                        relevanceRemarksCRC: value.entityAddress1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[1].fields.push(client1Arr);
                }
                if (value.interestNature !== null) {
                    client1Arr = {
                        fieldName: 'interestNature',
                        response: value.interestNature,
                        relevanceResponseCRC: value.interestNature1Relevance,
                        relevanceRemarksCRC: value.interestNature1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[1].fields.push(client1Arr);
                }
                if (value.date !== null) {
                    client1Arr = {
                        fieldName: 'date',
                        response: value.date,
                        relevanceResponseCRC: value.date1Relevance,
                        relevanceRemarksCRC: value.date1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[1].fields.push(client1Arr);
                }
                if (value.totInvestment !== null) {
                    client1Arr = {
                        fieldName: 'totInvestment',
                        response: value.totInvestment,
                        relevanceResponseCRC: value.totInvestment1Relevance,
                        relevanceRemarksCRC: value.totInvestment1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[1].fields.push(client1Arr);
                }
                if (value.interestIncome !== null) {
                    client1Arr = {
                        fieldName: 'interestIncome',
                        response: value.interestIncome,
                        relevanceResponseCRC: value.interstIncome1Relevance,
                        relevanceRemarksCRC: value.interstIncome1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[1].fields.push(client1Arr);
                }
                if (value.incomeNature !== null) {
                    client1Arr = {
                        fieldName: 'incomeNature',
                        response: value.incomeNature,
                        relevanceResponseCRC: value.incomeNature1Relevance,
                        relevanceRemarksCRC: value.incomeNature1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[1].fields.push(client1Arr);
                }
                return true;
            });
        }

        if (values.client2 !== null && values.client2 !== undefined) {
            values.client2.map((value, index) => {
                //console.log('index.....', index);
                let client2Arr = {};
                if (value.country !== null) {
                    client2Arr = {
                        fieldName: 'country',
                        response: value.country,
                        relevanceResponseCRC: value.country1Relevance,
                        relevanceRemarksCRC: value.country1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[2].fields.push(client2Arr);
                }

                if (value.propAddress !== null) {
                    client2Arr = {
                        fieldName: 'propAddress',
                        response: value.propAddress,
                        relevanceResponseCRC: value.propAddressRelevance,
                        relevanceRemarksCRC: value.propAddressRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[2].fields.push(client2Arr);
                }

                if (value.ownership !== null) {
                    client2Arr = {
                        fieldName: 'ownership',
                        response: value.ownership,
                        relevanceResponseCRC: value.ownershipRelevance,
                        relevanceRemarksCRC: value.ownershipRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[2].fields.push(client2Arr);
                }
                if (value.acqisitionDate !== null) {
                    client2Arr = {
                        fieldName: 'acqisitionDate',
                        response: value.acqisitionDate,
                        relevanceResponseCRC: value.acqisitionDateRelevance,
                        relevanceRemarksCRC: value.acqisitionDateRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[2].fields.push(client2Arr);
                }
                if (value.totInvestment !== null) {
                    client2Arr = {
                        fieldName: 'totInvestment',
                        response: value.totInvestment,
                        relevanceResponseCRC: value.totInvestmentRelevance,
                        relevanceRemarksCRC: value.totInvestmentRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[2].fields.push(client2Arr);
                }
                if (value.propIncome !== null) {
                    client2Arr = {
                        fieldName: 'propIncome',
                        response: value.propIncome,
                        relevanceResponseCRC: value.propIncomeRelevance,
                        relevanceRemarksCRC: value.propIncomeRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[2].fields.push(client2Arr);
                }
                if (value.incomeNature !== null) {
                    client2Arr = {
                        fieldName: 'incomeNature',
                        response: value.incomeNature,
                        relevanceResponseCRC: value.incomeNatureRelevance,
                        relevanceRemarksCRC: value.incomeNatureRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[2].fields.push(client2Arr);
                }
                return true;
            });
        }

        if (values.client3 !== null && values.client3 !== undefined) {
            values.client3.map((value, index) => {
                //console.log('index.....', index);
                let client3Arr = {};
                if (value.country !== null) {
                    client3Arr = {
                        fieldName: 'country',
                        response: value.country,
                        relevanceResponseCRC: value.country1Relevance,
                        relevanceRemarksCRC: value.country1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[3].fields.push(client3Arr);
                }

                if (value.assetName !== null) {
                    client3Arr = {
                        fieldName: 'assetName',
                        response: value.assetName,
                        relevanceResponseCRC: value.assetNameRelevance,
                        relevanceRemarksCRC: value.assetNameRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[3].fields.push(client3Arr);
                }

                if (value.ownership !== null) {
                    client3Arr = {
                        fieldName: 'ownership',
                        response: value.ownership,
                        relevanceResponseCRC: value.ownershipRelevance,
                        relevanceRemarksCRC: value.ownershipRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[3].fields.push(client3Arr);
                }
                if (value.acqisitionDate !== null) {
                    client3Arr = {
                        fieldName: 'acqisitionDate',
                        response: value.acqisitionDate,
                        relevanceResponseCRC: value.acqisitionDateRelevance,
                        relevanceRemarksCRC: value.acqisitionDateRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[3].fields.push(client3Arr);
                }
                if (value.totInvestment !== null) {
                    client3Arr = {
                        fieldName: 'totInvestment',
                        response: value.totInvestment,
                        relevanceResponseCRC: value.totInvestmentRelevance,
                        relevanceRemarksCRC: value.totInvestmentRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[3].fields.push(client3Arr);
                }
                if (value.assetIncome !== null) {
                    client3Arr = {
                        fieldName: 'assetIncome',
                        response: value.assetIncome,
                        relevanceResponseCRC: value.assetIncomeRelevance,
                        relevanceRemarksCRC: value.assetIncomeRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[3].fields.push(client3Arr);
                }
                if (value.incomeNature !== null) {
                    client3Arr = {
                        fieldName: 'incomeNature',
                        response: value.incomeNature,
                        relevanceResponseCRC: value.incomeNatureRelevance,
                        relevanceRemarksCRC: value.incomeNatureRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[3].fields.push(client3Arr);
                }
                return true;
            });
        }

        if (values.client4 !== null && values.client4 !== undefined) {
            values.client4.map((value, index) => {
                //console.log('index.....', index);
                let client4Arr = {};
                if (value.institutionName !== null) {
                    client4Arr = {
                        fieldName: 'institutionName',
                        response: value.institutionName,
                        relevanceResponseCRC: value.institutionNameRelevance,
                        relevanceRemarksCRC: value.institutionNameRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[4].fields.push(client4Arr);
                }
                if (value.institutionAddr !== null) {
                    client4Arr = {
                        fieldName: 'institutionAddr',
                        response: value.institutionAddr,
                        relevanceResponseCRC: value.institutionAddrRelevance,
                        relevanceRemarksCRC: value.institutionAddrRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[4].fields.push(client4Arr);
                }
                if (value.accholderName !== null) {
                    client4Arr = {
                        fieldName: 'accholderName',
                        response: value.accholderName,
                        relevanceResponseCRC: value.accholderNameRelevance,
                        relevanceRemarksCRC: value.accholderNameRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[4].fields.push(client4Arr);
                }

                if (value.accountNumber !== null) {
                    client4Arr = {
                        fieldName: 'accountNumber',
                        response: value.accountNumber,
                        relevanceResponseCRC: value.accountNumberRelevance,
                        relevanceRemarksCRC: value.accountNumberRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[4].fields.push(client4Arr);
                }
                if (value.peakBal !== null) {
                    client4Arr = {
                        fieldName: 'peakBal',
                        response: value.peakBal,
                        relevanceResponseCRC: value.peakBalRelevance,
                        relevanceRemarksCRC: value.peakBalRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[4].fields.push(client4Arr);
                }
                return true;
            });
        }

        if (values.client5 !== null && values.client5 !== undefined) {
            values.client5.map((value, index) => {
                //console.log('index.....', index);
                let client5Arr = {};
                if (value.country !== null) {
                    client5Arr = {
                        fieldName: 'country',
                        response: value.country,
                        relevanceResponseCRC: value.country1Relevance,
                        relevanceRemarksCRC: value.country1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[5].fields.push(client5Arr);
                }

                if (value.trustName !== null) {
                    client5Arr = {
                        fieldName: 'trustName',
                        response: value.trustName,
                        relevanceResponseCRC: value.trustNameRelevance,
                        relevanceRemarksCRC: value.trustNameRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[5].fields.push(client5Arr);
                }

                if (value.trustAddress !== null) {
                    client5Arr = {
                        fieldName: 'trustAddress',
                        response: value.trustAddress,
                        relevanceResponseCRC: value.trustAddressRelevance,
                        relevanceRemarksCRC: value.trustAddressRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[5].fields.push(client5Arr);
                }
                if (value.trusteeName !== null) {
                    client5Arr = {
                        fieldName: 'trusteeName',
                        response: value.trusteeName,
                        relevanceResponseCRC: value.trusteeNameRelevance,
                        relevanceRemarksCRC: value.trusteeNameRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[5].fields.push(client5Arr);
                }
                if (value.trusteeAddress !== null) {
                    client5Arr = {
                        fieldName: 'trusteeAddress',
                        response: value.trusteeAddress,
                        relevanceResponseCRC: value.trusteeAddressRelevance,
                        relevanceRemarksCRC: value.trusteeAddressRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[5].fields.push(client5Arr);
                }
                if (value.settlorAddress !== null) {
                    client5Arr = {
                        fieldName: 'settlorAddress',
                        response: value.settlorAddress,
                        relevanceResponseCRC: value.settlorAddressRelevance,
                        relevanceRemarksCRC: value.settlorAddressRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[5].fields.push(client5Arr);
                }
                if (value.settlorName !== null) {
                    client5Arr = {
                        fieldName: 'settlorName',
                        response: value.settlorName,
                        relevanceResponseCRC: value.settlorNameRelevance,
                        relevanceRemarksCRC: value.settlorNameRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[5].fields.push(client5Arr);
                }
                if (value.benfName !== null) {
                    client5Arr = {
                        fieldName: 'benfName',
                        response: value.benfName,
                        relevanceResponseCRC: value.benfNameRelevance,
                        relevanceRemarksCRC: value.benfNameRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[5].fields.push(client5Arr);
                }
                if (value.benfAddress !== null) {
                    client5Arr = {
                        fieldName: 'benfAddress',
                        response: value.benfAddress,
                        relevanceResponseCRC: value.benfAddressRelevance,
                        relevanceRemarksCRC: value.benfAddressRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[5].fields.push(client5Arr);
                }

                return true;
            });
        }

        if (values.client6 !== null && values.client6 !== undefined) {
            values.client6.map((value, index) => {
                //console.log('index.....', index);
                let client6Arr = {};
                if (value.country !== null) {
                    client6Arr = {
                        fieldName: 'country',
                        response: value.country,
                        relevanceResponseCRC: value.country1Relevance,
                        relevanceRemarksCRC: value.country1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[6].fields.push(client6Arr);
                }

                if (value.personName !== null) {
                    client6Arr = {
                        fieldName: 'personName',
                        response: value.personName,
                        relevanceResponseCRC: value.personNameRelevance,
                        relevanceRemarksCRC: value.personNameRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[6].fields.push(client6Arr);
                }

                if (value.personAddr !== null) {
                    client6Arr = {
                        fieldName: 'personAddr',
                        response: value.personAddr,
                        relevanceResponseCRC: value.personAddrRelevance,
                        relevanceRemarksCRC: value.personAddrRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[6].fields.push(client6Arr);
                }
                if (value.derivedIncome !== null) {
                    client6Arr = {
                        fieldName: 'derivedIncome',
                        response: value.derivedIncome,
                        relevanceResponseCRC: value.derivedIncomeRelevance,
                        relevanceRemarksCRC: value.derivedIncomeRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[6].fields.push(client6Arr);
                }

                if (value.incomeNature !== null) {
                    client6Arr = {
                        fieldName: 'incomeNature',
                        response: value.incomeNature,
                        relevanceResponseCRC: value.incomeNatureRelevance,
                        relevanceRemarksCRC: value.incomeNatureRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[6].fields.push(client6Arr);
                }
                return true;
            });
        }

        if (values.client7 !== null && values.client7 !== undefined) {
            values.client7.map((value, index) => {
                //console.log('index.....', index);
                let client7Arr = {};
                if (value.country !== null) {
                    client7Arr = {
                        fieldName: 'country',
                        response: value.country,
                        relevanceResponseCRC: value.country1Relevance,
                        relevanceRemarksCRC: value.country1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[7].fields.push(client7Arr);
                }

                if (value.institutionName !== null) {
                    client7Arr = {
                        fieldName: 'institutionName',
                        response: value.institutionName,
                        relevanceResponseCRC: value.institutionNameRelevance,
                        relevanceRemarksCRC: value.institutionNameRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[7].fields.push(client7Arr);
                }

                if (value.institutionAddr !== null) {
                    client7Arr = {
                        fieldName: 'institutionAddr',
                        response: value.institutionAddr,
                        relevanceResponseCRC: value.institutionAddrRelevance,
                        relevanceRemarksCRC: value.institutionAddrRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[7].fields.push(client7Arr);
                }
                if (value.zip !== null) {
                    client7Arr = {
                        fieldName: 'zip',
                        response: value.zip,
                        relevanceResponseCRC: value.zipRelevance,
                        relevanceRemarksCRC: value.zipRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[7].fields.push(client7Arr);
                }

                if (value.accountNumber !== null) {
                    client7Arr = {
                        fieldName: 'accountNumber',
                        response: value.accountNumber,
                        relevanceResponseCRC: value.accountNumberRelevance,
                        relevanceRemarksCRC: value.accountNumberRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[7].fields.push(client7Arr);
                }
                if (value.status !== null) {
                    client7Arr = {
                        fieldName: 'status',
                        response: value.status,
                        relevanceResponseCRC: value.statusRelevance,
                        relevanceRemarksCRC: value.statusRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[7].fields.push(client7Arr);
                }

                if (value.date !== null) {
                    client7Arr = {
                        fieldName: 'date',
                        response: value.date,
                        relevanceResponseCRC: value.dateRelevance,
                        relevanceRemarksCRC: value.dateRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[7].fields.push(client7Arr);
                }
                if (value.peakBalance !== null) {
                    client7Arr = {
                        fieldName: 'peakBalance',
                        response: value.peakBalance,
                        relevanceResponseCRC: value.peakBalanceRelevance,
                        relevanceRemarksCRC: value.peakBalanceRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[7].fields.push(client7Arr);
                }

                if (value.closingBalance !== null) {
                    client7Arr = {
                        fieldName: 'closingBalance',
                        response: value.closingBalance,
                        relevanceResponseCRC: value.closingBalanceRelevance,
                        relevanceRemarksCRC: value.closingBalanceRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[7].fields.push(client7Arr);
                }
                return true;
            });
        }

        if (values.client8 !== null && values.client8 !== undefined) {
            values.client8.map((value, index) => {
                //console.log('index.....', index);
                let client8Arr = {};
                if (value.country !== null) {
                    client8Arr = {
                        fieldName: 'country',
                        response: value.country,
                        relevanceResponseCRC: value.country1Relevance,
                        relevanceRemarksCRC: value.country1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[8].fields.push(client8Arr);
                }

                if (value.institutionName !== null) {
                    client8Arr = {
                        fieldName: 'institutionName',
                        response: value.institutionName,
                        relevanceResponseCRC: value.institutionNameRelevance,
                        relevanceRemarksCRC: value.institutionNameRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[8].fields.push(client8Arr);
                }

                if (value.institutionAddr !== null) {
                    client8Arr = {
                        fieldName: 'institutionAddr',
                        response: value.institutionAddr,
                        relevanceResponseCRC: value.institutionAddrRelevance,
                        relevanceRemarksCRC: value.institutionAddrRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[8].fields.push(client8Arr);
                }
                if (value.zip !== null) {
                    client8Arr = {
                        fieldName: 'zip',
                        response: value.zip,
                        relevanceResponseCRC: value.zipRelevance,
                        relevanceRemarksCRC: value.zipRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[8].fields.push(client8Arr);
                }

                if (value.accountNumber !== null) {
                    client8Arr = {
                        fieldName: 'accountNumber',
                        response: value.accountNumber,
                        relevanceResponseCRC: value.accountNumberRelevance,
                        relevanceRemarksCRC: value.accountNumberRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[8].fields.push(client8Arr);
                }
                if (value.status !== null) {
                    client8Arr = {
                        fieldName: 'status',
                        response: value.status,
                        relevanceResponseCRC: value.statusRelevance,
                        relevanceRemarksCRC: value.statusRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[8].fields.push(client8Arr);
                }

                if (value.date !== null) {
                    client8Arr = {
                        fieldName: 'date',
                        response: value.date,
                        relevanceResponseCRC: value.dateRelevance,
                        relevanceRemarksCRC: value.dateRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[8].fields.push(client8Arr);
                }
                if (value.peakBalance !== null) {
                    client8Arr = {
                        fieldName: 'peakBalance',
                        response: value.peakBalance,
                        relevanceResponseCRC: value.peakBalanceRelevance,
                        relevanceRemarksCRC: value.peakBalanceRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[8].fields.push(client8Arr);
                }

                if (value.closingBalance !== null) {
                    client8Arr = {
                        fieldName: 'closingBalance',
                        response: value.closingBalance,
                        relevanceResponseCRC: value.closingBalanceRelevance,
                        relevanceRemarksCRC: value.closingBalanceRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[8].fields.push(client8Arr);
                }

                if (value.grossAmount !== null) {
                    client8Arr = {
                        fieldName: 'grossAmount',
                        response: value.grossAmount,
                        relevanceResponseCRC: value.grossAmountRelevance,
                        relevanceRemarksCRC: value.grossAmountRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[8].fields.push(client8Arr);
                }
                return true;
            });
        }

        if (values.client9 !== null && values.client9 !== undefined) {
            values.client9.map((value, index) => {
                //console.log('index.....', index);
                let client9Arr = {};
                if (value.country !== null) {
                    client9Arr = {
                        fieldName: 'country',
                        response: value.country,
                        relevanceResponseCRC: value.country1Relevance,
                        relevanceRemarksCRC: value.country1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[9].fields.push(client9Arr);
                }

                if (value.entityName !== null) {
                    client9Arr = {
                        fieldName: 'entityName',
                        response: value.entityName,
                        relevanceResponseCRC: value.entityNameRelevance,
                        relevanceRemarksCRC: value.entityNameRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[9].fields.push(client9Arr);
                }

                if (value.entityAddress !== null) {
                    client9Arr = {
                        fieldName: 'entityAddress',
                        response: value.entityAddress,
                        relevanceResponseCRC: value.entityAddressRelevance,
                        relevanceRemarksCRC: value.entityAddressRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[9].fields.push(client9Arr);
                }
                if (value.zip !== null) {
                    client9Arr = {
                        fieldName: 'zip',
                        response: value.zip,
                        relevanceResponseCRC: value.zipRelevance,
                        relevanceRemarksCRC: value.zipRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[9].fields.push(client9Arr);
                }

                if (value.entityNature !== null) {
                    client9Arr = {
                        fieldName: 'entityNature',
                        response: value.entityNature,
                        relevanceResponseCRC: value.entityNatureRelevance,
                        relevanceRemarksCRC: value.entityNatureRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[9].fields.push(client9Arr);
                }
                if (value.acquireDate !== null) {
                    client9Arr = {
                        fieldName: 'acquireDate',
                        response: value.acquireDate,
                        relevanceResponseCRC: value.acquireDateRelevance,
                        relevanceRemarksCRC: value.acquireDateRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[9].fields.push(client9Arr);
                }

                if (value.initialInvest !== null) {
                    client9Arr = {
                        fieldName: 'initialInvest',
                        response: value.initialInvest,
                        relevanceResponseCRC: value.initialInvestRelevance,
                        relevanceRemarksCRC: value.initialInvestRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[9].fields.push(client9Arr);
                }
                if (value.peakInvest !== null) {
                    client9Arr = {
                        fieldName: 'peakInvest',
                        response: value.peakInvest,
                        relevanceResponseCRC: value.peakInvestRelevance,
                        relevanceRemarksCRC: value.peakInvestRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[9].fields.push(client9Arr);
                }

                if (value.closingBalance !== null) {
                    client9Arr = {
                        fieldName: 'closingBalance',
                        response: value.closingBalance,
                        relevanceResponseCRC: value.closingBalanceRelevance,
                        relevanceRemarksCRC: value.closingBalanceRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[9].fields.push(client9Arr);
                }

                if (value.grossAmount !== null) {
                    client9Arr = {
                        fieldName: 'grossAmount',
                        response: value.grossAmount,
                        relevanceResponseCRC: value.grossAmountRelevance,
                        relevanceRemarksCRC: value.grossAmountRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[9].fields.push(client9Arr);
                }
                return true;
            });
        }

        if (values.client10 !== null && values.client10 !== undefined) {
            values.client10.map((value, index) => {
                //console.log('index.....', index);
                let client10Arr = {};
                if (value.country !== null) {
                    client10Arr = {
                        fieldName: 'country',
                        response: value.country,
                        relevanceResponseCRC: value.country1Relevance,
                        relevanceRemarksCRC: value.country1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[10].fields.push(client10Arr);
                }

                if (value.instiName !== null) {
                    client10Arr = {
                        fieldName: 'instiName',
                        response: value.instiName,
                        relevanceResponseCRC: value.instiNameRelevance,
                        relevanceRemarksCRC: value.instiNameRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[10].fields.push(client10Arr);
                }

                if (value.instiAddr !== null) {
                    client10Arr = {
                        fieldName: 'instiAddr',
                        response: value.instiAddr,
                        relevanceResponseCRC: value.instiAddrRelevance,
                        relevanceRemarksCRC: value.instiAddrRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[10].fields.push(client10Arr);
                }
                if (value.zip !== null) {
                    client10Arr = {
                        fieldName: 'zip',
                        response: value.zip,
                        relevanceResponseCRC: value.zipRelevance,
                        relevanceRemarksCRC: value.zipRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[10].fields.push(client10Arr);
                }
                if (value.date !== null) {
                    client10Arr = {
                        fieldName: 'date',
                        response: value.date,
                        relevanceResponseCRC: value.dateRelevance,
                        relevanceRemarksCRC: value.dateRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[10].fields.push(client10Arr);
                }
                if (value.cashValue !== null) {
                    client10Arr = {
                        fieldName: 'cashValue',
                        response: value.cashValue,
                        relevanceResponseCRC: value.cashValueRelevance,
                        relevanceRemarksCRC: value.cashValueRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[10].fields.push(client10Arr);
                }
                if (value.grossValue !== null) {
                    client10Arr = {
                        fieldName: 'grossValue',
                        response: value.grossValue,
                        relevanceResponseCRC: value.grossValueRelevance,
                        relevanceRemarksCRC: value.grossValueRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[10].fields.push(client10Arr);
                }
                return true;
            });
        }

        if (values.labelAdata !== null && values.labelAdata !== undefined) {
            values.labelAdata.map((value, index) => {
                //console.log('labelAdata..value', value);
                let labelAdataArr = {};
                if (value.description !== null) {
                    labelAdataArr = {
                        fieldName: 'description',
                        response: value.description,
                        relevanceResponseCRC: value.descriptionRelevance,
                        relevanceRemarksCRC: value.descriptionRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[0].fields.push(labelAdataArr);
                }
                if (value.address !== null) {
                    labelAdataArr = {
                        fieldName: 'address',
                        response: value.address,
                        relevanceResponseCRC: value.addressRelevance,
                        relevanceRemarksCRC: value.addressRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[0].fields.push(labelAdataArr);
                }
                if (value.amount !== null) {
                    labelAdataArr = {
                        fieldName: 'amount',
                        response: value.amount,
                        relevanceResponseCRC: value.amountRelevance,
                        relevanceRemarksCRC: value.amountRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[0].fields.push(labelAdataArr);
                }
                return true;
            });
        }

        if (values.labelBdata !== null && values.labelBdata !== undefined) {
            values.labelBdata.map((value, index) => {
                //console.log('labelBdata..value', value);
                let labelBdataArr = {};
                if (value.jewellaryBullions !== null) {
                    labelBdataArr = {
                        fieldName: 'jewellaryBullions',
                        response: value.jewellaryBullions,
                        relevanceResponseCRC: value.jewellaryBullionsRelevance,
                        relevanceRemarksCRC: value.jewellaryBullionsRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[1].fields.push(labelBdataArr);
                }
                if (value.archaeologicalCollections !== null) {
                    labelBdataArr = {
                        fieldName: 'archaeologicalCollections',
                        response: value.archaeologicalCollections,
                        relevanceResponseCRC: value.archaeologicalCollectionsRelevance,
                        relevanceRemarksCRC: value.archaeologicalCollectionsRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[1].fields.push(labelBdataArr);
                }
                if (value.vehiclesYatchBoatsAircrafts !== null) {
                    labelBdataArr = {
                        fieldName: 'vehiclesYatchBoatsAircrafts',
                        response: value.vehiclesYatchBoatsAircrafts,
                        relevanceResponseCRC: value.vehiclesYatchBoatsAircraftsRelevance,
                        relevanceRemarksCRC: value.vehiclesYatchBoatsAircraftsRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[1].fields.push(labelBdataArr);
                }
                if (value.faAAmount !== null) {
                    labelBdataArr = {
                        fieldName: 'faAAmount',
                        response: value.faAAmount,
                        relevanceResponseCRC: value.faAAmountRelevance,
                        relevanceRemarksCRC: value.faAAmountRelevanceRemarks,
                        relevanceResponseAM: 'Relevant',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[1].fields.push(labelBdataArr);
                }
                if (value.faBAmount !== null) {
                    labelBdataArr = {
                        fieldName: 'faBAmount',
                        response: value.faBAmount,
                        relevanceResponseCRC: value.faBAmountRelevance,
                        relevanceRemarksCRC: value.faBAmountRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[1].fields.push(labelBdataArr);
                }
                if (value.faCAmount !== null) {
                    labelBdataArr = {
                        fieldName: 'faCAmount',
                        response: value.faCAmount,
                        relevanceResponseCRC: value.faCAmountRelevance,
                        relevanceRemarksCRC: value.faCAmountRelevance,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[1].fields.push(labelBdataArr);
                }
                if (value.faDAmount !== null) {
                    labelBdataArr = {
                        fieldName: 'faDAmount',
                        response: value.faDAmount,
                        relevanceResponseCRC: value.faDAmountRelevance,
                        relevanceRemarksCRC: value.faDAmountRelevance,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[1].fields.push(labelBdataArr);
                }
                if (value.faEAmount !== null) {
                    labelBdataArr = {
                        fieldName: 'faEAmount',
                        response: value.faEAmount,
                        relevanceResponseCRC: value.faEAmountRelevance,
                        relevanceRemarksCRC: value.faEAmountRelevance,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[1].fields.push(labelBdataArr);
                }
                return true;
            });
        }

        if (values.labelCdata !== null && values.labelCdata !== undefined) {
            values.labelCdata.map((value, index) => {
                //console.log('labelBdata..value', value);
                let labelCdataArr = {};
                if (value.name !== null) {
                    labelCdataArr = {
                        fieldName: 'name',
                        response: value.name,
                        relevanceResponseCRC: value.nameCRelevance,
                        relevanceRemarksCRC: value.nameCRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[2].fields.push(labelCdataArr);
                }
                if (value.pan !== null) {
                    labelCdataArr = {
                        fieldName: 'pan',
                        response: value.pan,
                        relevanceResponseCRC: value.panCRelevance,
                        relevanceRemarksCRC: value.panCRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[2].fields.push(labelCdataArr);
                }
                if (value.particularShare !== null) {
                    labelCdataArr = {
                        fieldName: 'particularShare',
                        response: value.particularShare,
                        relevanceResponseCRC: value.particularShareCRelevance,
                        relevanceRemarksCRC: value.particularShareCRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[2].fields.push(labelCdataArr);
                }
                if (value.particularCost !== null) {
                    labelCdataArr = {
                        fieldName: 'particularCost',
                        response: value.particularCost,
                        relevanceResponseCRC: value.particularCostCRelevance,
                        relevanceRemarksCRC: value.particularCostCRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[2].fields.push(labelCdataArr);
                }
                if (value.acquiredShare !== null) {
                    labelCdataArr = {
                        fieldName: 'acquiredShare',
                        response: value.acquiredShare,
                        relevanceResponseCRC: value.acquiredShareCRelevance,
                        relevanceRemarksCRC: value.acquiredShareCRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[2].fields.push(labelCdataArr);
                }
                if (value.acquiredDate !== null) {
                    labelCdataArr = {
                        fieldName: 'acquiredDate',
                        response: value.acquiredDate,
                        relevanceResponseCRC: value.acquiredDateCRelevance,
                        relevanceRemarksCRC: value.acquiredDateCRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[2].fields.push(labelCdataArr);
                }
                if (value.acquiredValue !== null) {
                    labelCdataArr = {
                        fieldName: 'acquiredValue',
                        response: value.acquiredValue,
                        relevanceResponseCRC: value.acquiredValueCRelevance,
                        relevanceRemarksCRC: value.acquiredValueCRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[2].fields.push(labelCdataArr);
                }
                if (value.acquiredIssuePrice !== null) {
                    labelCdataArr = {
                        fieldName: 'acquiredIssuePrice',
                        response: value.acquiredIssuePrice,
                        relevanceResponseCRC: value.acquiredIPCRelevance,
                        relevanceRemarksCRC: value.acquiredIPCRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[2].fields.push(labelCdataArr);
                }
                if (value.acquiredPurchasePrice !== null) {
                    labelCdataArr = {
                        fieldName: 'acquiredPurchasePrice',
                        response: value.acquiredPurchasePrice,
                        relevanceResponseCRC: value.acquiredPPCRelevance,
                        relevanceRemarksCRC: value.acquiredPPCRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[2].fields.push(labelCdataArr);
                }
                if (value.transferredShare !== null) {
                    labelCdataArr = {
                        fieldName: 'transferredShare',
                        response: value.transferredShare,
                        relevanceResponseCRC: value.tsCRelevance,
                        relevanceRemarksCRC: value.tsCRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[2].fields.push(labelCdataArr);
                }
                if (value.transferredSale !== null) {
                    labelCdataArr = {
                        fieldName: 'transferredSale',
                        response: value.transferredSale,
                        relevanceResponseCRC: value.tsaleCRelevance,
                        relevanceRemarksCRC: value.tsaleCRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[2].fields.push(labelCdataArr);
                }
                if (value.closingShare !== null) {
                    labelCdataArr = {
                        fieldName: 'closingShare',
                        response: value.closingShare,
                        relevanceResponseCRC: value.closingShareCRelevance,
                        relevanceRemarksCRC: value.closingSharetsaleCRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[2].fields.push(labelCdataArr);
                }
                if (value.closingCost !== null) {
                    labelCdataArr = {
                        fieldName: 'closingCost',
                        response: value.closingCost,
                        relevanceResponseCRC: value.closingCostCRelevance,
                        relevanceRemarksCRC: value.closingCostsaleCRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[2].fields.push(labelCdataArr);
                }
                if (value.closingSale !== null) {
                    labelCdataArr = {
                        fieldName: 'closingSale',
                        response: value.closingSale,
                        relevanceResponseCRC: value.closingSaleCRelevance,
                        relevanceRemarksCRC: value.closingSaleCRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[2].fields.push(labelCdataArr);
                }
                if (value.noOfShare !== null) {
                    labelCdataArr = {
                        fieldName: 'noOfShare',
                        response: value.noOfShare,
                        relevanceResponseCRC: value.noOfShareCRelevance,
                        relevanceRemarksCRC: value.noOfShareCRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[2].fields.push(labelCdataArr);
                }
                if (value.costOfAcquisition !== null) {
                    labelCdataArr = {
                        fieldName: 'costOfAcquisition',
                        response: value.costOfAcquisition,
                        relevanceResponseCRC: value.costOfAcquisitionCRelevance,
                        relevanceRemarksCRC: value.costOfAcquisitionCRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[2].fields.push(labelCdataArr);
                }
                return true;
            });
        }

        if (values.labelDdata !== null && values.labelDdata !== undefined) {
            values.labelDdata.map((value, index) => {
                //console.log('labelDdata..value', value);
                let labelDdataArr = {};
                if (value.name !== null) {
                    labelDdataArr = {
                        fieldName: 'name',
                        response: value.name,
                        relevanceResponseCRC: value.nameDRelevance,
                        relevanceRemarksCRC: value.nameDRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[3].fields.push(labelDdataArr);
                }
                if (value.pan !== null) {
                    labelDdataArr = {
                        fieldName: 'pan',
                        response: value.pan,
                        relevanceResponseCRC: value.panDRelevance,
                        relevanceRemarksCRC: value.panDRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[3].fields.push(labelDdataArr);
                }
                if (value.value !== null) {
                    labelDdataArr = {
                        fieldName: 'value',
                        response: value.value,
                        relevanceResponseCRC: value.valueDRelevance,
                        relevanceRemarksCRC: value.valueDRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[3].fields.push(labelDdataArr);
                }
                return true;
            });
        }

        if (values.labelEdata !== null && values.labelEdata !== undefined) {
            values.labelEdata.map((value, index) => {
                //console.log('labelEdata..value', value);
                let labelEdataArr = {};
                if (value.particular !== null) {
                    labelEdataArr = {
                        fieldName: 'particular',
                        response: value.particular,
                        relevanceResponseCRC: value.particularRelevance,
                        relevanceRemarksCRC: value.particularRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[4].fields.push(labelEdataArr);
                }
                if (value.amount !== null) {
                    labelEdataArr = {
                        fieldName: 'amount',
                        response: value.amount,
                        relevanceResponseCRC: value.amountERelevance,
                        relevanceRemarksCRC: value.amountERelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[4].fields.push(labelEdataArr);
                }
                return true;
            });
        }
        if (values.capitalgain !== null && values.capitalgain !== undefined) {
            values.capitalgain.map((value, index) => {
                //console.log('capitalgain..value', value);
                let capitalgainArr = {};
                if (value.natureAssets !== null) {
                    capitalgainArr = {
                        fieldName: 'natureAssets',
                        response: value.natureAssets,
                        relevanceResponseCRC: value.balanceCRCrelevenceResponse,
                        relevanceRemarksCRC: value.balanceCRCrelevenceRemarks,
                        relevanceResponseAM: 'Relevant',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[3].fields.push(capitalgainArr);
                }
                if (value.natureAssetsUpload !== null) {
                    capitalgainArr = {
                        fieldName: 'natureAssetsUpload',
                        response: value.natureAssetsUpload,
                        relevanceResponseCRC: '',
                        relevanceRemarksCRC: '',
                        relevanceResponseAM: 'Relevant',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[3].fields.push(capitalgainArr);
                }
                return true;
            });
        }

        if (values.agriculture !== null && values.agriculture !== undefined) {
            values.agriculture.map((value, index) => {
                // console.log('agriculture..value', value);
                let agricultureArr = {};
                if (value.agricultureName !== null) {
                    agricultureArr = {
                        fieldName: 'agricultureName',
                        response: value.agricultureName,
                        relevanceResponseCRC: value.agricultureNameCRCrelevenceResponse,
                        relevanceRemarksCRC: value.agricultureNameCRCrelevenceRemarks,
                        relevanceResponseAM: 'Relevant',
                        relevanceRemarksAM: '',
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[5].fields.push(agricultureArr);
                }
                if (value.agriAmount !== null) {
                    agricultureArr = {
                        fieldName: 'agriAmount',
                        response: value.agriAmount,
                        relevanceResponseCRC: value.agriAmountCRCrelevenceResponse,
                        relevanceRemarksCRC: value.agriAmountCRCrelevenceRemarks,
                        relevanceResponseAM: 'Relevant',
                        relevanceRemarksAM: '',
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[5].fields.push(agricultureArr);
                }
                if (value.agriReceipt !== null) {
                    agricultureArr = {
                        fieldName: 'agriReceipt',
                        response: value.agriReceipt,
                        relevanceResponseCRC: value.agriReceiptCRCrelevenceResponse,
                        relevanceRemarksCRC: value.agriReceiptCRCrelevenceRemarks,
                        relevanceResponseAM: 'Relevant',
                        relevanceRemarksAM: '',
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[5].fields.push(agricultureArr);
                }
                if (value.agriExpenses !== null) {
                    agricultureArr = {
                        fieldName: 'agriExpenses',
                        response: value.agriExpenses,
                        relevanceResponseCRC: value.agriExpensesCRCrelevenceResponse,
                        relevanceRemarksCRC: value.agriExpensesCRCrelevenceRemarks,
                        relevanceResponseAM: 'Relevant',
                        relevanceRemarksAM: '',
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[5].fields.push(agricultureArr);
                }
                if (value.agriReceiptUpload !== null) {
                    agricultureArr = {
                        fieldName: 'agriReceiptUpload',
                        response: value.agriReceiptUpload,
                        relevanceResponseCRC: value.agriReceiptUploadCRCrelevenceResponse,
                        relevanceRemarksCRC: value.agriReceiptUploadCRCrelevenceRemarks,
                        relevanceResponseAM: 'Relevant',
                        relevanceRemarksAM: '',
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[5].fields.push(agricultureArr);
                }
                if (value.agricultureName !== null) {
                    agricultureArr = {
                        fieldName: 'agriExpensesUpload',
                        response: value.agriExpensesUpload,
                        relevanceResponseCRC: value.agriExpensesUploadCRCrelevenceResponse,
                        relevanceRemarksCRC: value.agriExpensesUploadCRCrelevenceRemarks,
                        relevanceResponseAM: 'Relevant',
                        relevanceRemarksAM: '',
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[5].fields.push(agricultureArr);
                }
                return true;
            });
        }

        if (values.divident !== null && values.divident !== undefined) {
            values.divident.map((value, index) => {
                //console.log('othersources..2516', value);
                let dividentArr = {};
                if (value.divPayer !== null) {
                    dividentArr = {
                        fieldName: 'divPayer',
                        response: value.divPayer,
                        relevanceResponseCRC: value.divPayerCRCrelevenceResponse,
                        relevanceRemarksCRC: value.divPayerCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[0].fields.push(dividentArr);
                }
                if (value.divAmount !== null) {
                    dividentArr = {
                        fieldName: 'divAmount',
                        response: value.divAmount,
                        relevanceResponseCRC: value.divAmountCRCrelevenceResponse,
                        relevanceRemarksCRC: value.divAmountCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[0].fields.push(dividentArr);
                }
                if (value.divUpload !== null) {
                    dividentArr = {
                        fieldName: 'divUpload',
                        response: value.divUpload,
                        relevanceResponseCRC: '',
                        relevanceRemarksCRC: '',
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[0].fields.push(dividentArr);
                }
                return true;
            });
        }
        if (values.fd !== null && values.fd !== undefined) {
            values.fd.map((value, index) => {
                //console.log('capitalgain..value', value);
                let fdArr = {};
                if (value.fdPayer !== null) {
                    fdArr = {
                        fieldName: 'fdPayer',
                        response: value.fdPayer,
                        relevanceResponseCRC: value.fdPayerCRCrelevenceResponse,
                        relevanceRemarksCRC: value.fdPayerCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[1].fields.push(fdArr);
                }
                if (value.fdAmount !== null) {
                    fdArr = {
                        fieldName: 'fdAmount',
                        response: value.fdAmount,
                        relevanceResponseCRC: value.fdAmountCRCrelevenceResponse,
                        relevanceRemarksCRC: value.fdAmountCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[1].fields.push(fdArr);
                }
                if (value.fdUpload !== null) {
                    fdArr = {
                        fieldName: 'fdUpload',
                        response: value.fdUpload,
                        relevanceResponseCRC: '',
                        relevanceRemarksCRC: '',
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[1].fields.push(fdArr);
                }
                return true;
            });
        }

        if (values.othersources !== null && values.othersources !== undefined) {
            values.othersources.map((value, index) => {
                //console.log('capitalgain..value', value);
                let otherArr = {};
                if (value.otherPayer !== null) {
                    otherArr = {
                        fieldName: 'otherPayer',
                        response: value.otherPayer,
                        relevanceResponseCRC: value.otherPayerCRCrelevenceResponse,
                        relevanceRemarksCRC: value.otherPayerCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[2].fields.push(otherArr);
                }
                if (value.otherAmount !== null) {
                    otherArr = {
                        fieldName: 'otherAmount',
                        response: value.otherAmount,
                        relevanceResponseCRC: value.otherAmountCRCrelevenceResponse,
                        relevanceRemarksCRC: value.otherAmountCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[2].fields.push(otherArr);
                }
                if (value.otherUpload !== null) {
                    otherArr = {
                        fieldName: 'otherUpload',
                        response: value.otherUpload,
                        relevanceResponseCRC: '',
                        relevanceRemarksCRC: '',
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[2].fields.push(otherArr);
                }
                return true;
            });
        }

        if (values.bankDetails !== null && values.bankDetails !== undefined) {
            values.bankDetails.map((value, index) => {
                //console.log('Bank Details Value', value);
                let bankDetailsArr = {};
                if (value.bankName !== null) {
                    bankDetailsArr = {
                        fieldName: 'bankName',
                        response: value.bankName,
                        relevanceResponseCRC: value.bankNameRelevance,
                        relevanceRemarksCRC: value.bankNameRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[1].fields.push(bankDetailsArr);
                }
                if (value.accountNumber !== null) {
                    bankDetailsArr = {
                        fieldName: 'accountNumber',
                        response: value.accountNumber,
                        relevanceResponseCRC: value.accountNoRelevance,
                        relevanceRemarksCRC: value.accountNoRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[1].fields.push(bankDetailsArr);
                }
                if (value.ifscCode !== null) {
                    bankDetailsArr = {
                        fieldName: 'ifscCode',
                        response: value.ifscCode,
                        relevanceResponseCRC: value.ifscCodeRelevance,
                        relevanceRemarksCRC: value.ifscCodeRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[1].fields.push(bankDetailsArr);
                }
                if (value.typeOfAcc !== null) {
                    bankDetailsArr = {
                        fieldName: 'typeOfAcc',
                        response: value.typeOfAcc,
                        relevanceResponseCRC: value.accTypeRelevance,
                        relevanceRemarksCRC: value.accTypeRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[1].fields.push(bankDetailsArr);
                }
                if (value.interestOfSavingsBank !== null) {
                    bankDetailsArr = {
                        fieldName: 'interestOfSavingsBank',
                        response: value.interestOfSavingsBank,
                        relevanceResponseCRC: value.jointAccNameRelevance,
                        relevanceRemarksCRC: value.jointAccNameRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[1].fields.push(bankDetailsArr);
                }
                if (value.checkedBank !== null) {
                    bankDetailsArr = {
                        fieldName: 'checkedBank',
                        response: value.checkedBank,
                        relevanceResponseCRC: value.checkedBankRelevance,
                        relevanceRemarksCRC: value.checkedBankRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[1].fields.push(bankDetailsArr);
                }
                if (value.bankStatementUpload !== null) {
                    bankDetailsArr = {
                        fieldName: 'bankStatementUpload',
                        response: value.bankStatementUpload,
                        relevanceResponseCRC: '',
                        relevanceRemarksCRC: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[1].fields.push(bankDetailsArr);
                }
                return true;
            });
        }

        if (values.investment !== null && values.investment !== undefined) {
            values.investment.map((value, index) => {
                //console.log('investment..value', value);
                let investmentArr = {};
                if (value.investmentDetails !== null) {
                    investmentArr = {
                        fieldName: 'investmentDetails',
                        response: value.investmentDetails,
                        relevanceResponseCRC: value.investmentDetailsCRCRelevenceResponse,
                        relevanceRemarksCRC: value.investmentDetailsCRCRelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[1].fields.push(investmentArr);
                }
                if (value.investmentAmt !== null) {
                    investmentArr = {
                        fieldName: 'investmentAmt',
                        response: value.investmentAmt,
                        relevanceResponseCRC: value.investmentAmtCRCRelevenceResponse,
                        relevanceRemarksCRC: value.investmentAmtCRCRelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[1].fields.push(investmentArr);
                }
                if (value.invAmtUpload !== null) {
                    investmentArr = {
                        fieldName: 'invAmtUpload',
                        response: value.invAmtUpload,
                        relevanceResponseCRC: value.invAmtUploadCRCRelevenceResponse,
                        relevanceRemarksCRC: value.invAmtUploadCRCRelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[1].fields.push(investmentArr);
                }
                return true;
            });
        }

        if (values.donation !== null && values.donation !== undefined) {
            values.donation.map((value, index) => {
                let donationArr = {};
                if (value.donationDetails !== null) {
                    donationArr = {
                        fieldName: 'donationDetails',
                        response: value.donationDetails,
                        relevanceResponseCRC: value.donationDetailsCRCRelevenceResponse,
                        relevanceRemarksCRC: value.donationDetailsCRCRelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[2].fields.push(donationArr);
                }

                if (value.donationAmt !== null) {
                    donationArr = {
                        fieldName: 'donationAmt',
                        response: value.donationAmt,
                        relevanceResponseCRC: value.donationAmountCRCRelevenceResponse,
                        relevanceRemarksCRC: value.donationAmountCRCRelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[2].fields.push(donationArr);
                }
                if (value.donationAmtUpload !== null) {
                    donationArr = {
                        fieldName: 'donationAmtUpload',
                        response: value.donationAmtUpload,
                        relevanceResponseCRC: value.donationAmtUploadCRCRelevenceResponse,
                        relevanceRemarksCRC: value.donationAmtUploadCRCRelevenceRemarks,
                        relevanceResponseAM: 'Relevant',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[2].fields.push(donationArr);
                }
                return true;
            });
        }

        if (values.houseproperty !== null && values.houseproperty !== undefined) {
            values.houseproperty.map((value, index) => {
                let housePropertyIndex = index;
                let houseAddressArr = {};
                if (value.houseAddress !== null) {
                    houseAddressArr = {
                        fieldName: 'houseAddress',
                        response: value.houseAddress,
                        relevanceResponseCRC: value.houseAddressCRCrelevenceResponse,
                        relevanceRemarksCRC: value.houseAddressCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[1].fields.push(houseAddressArr);
                }

                if (value.houseStatusType !== null) {
                    houseAddressArr = {
                        fieldName: 'houseStatusType',
                        response: value.houseStatusType,
                        relevanceResponseCRC: value.houseStatusTypeCRCrelevenceResponse,
                        relevanceRemarksCRC: value.houseStatusTypeCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[1].fields.push(houseAddressArr);
                }

                if (value.rent !== null) {
                    houseAddressArr = {
                        fieldName: 'rentreceived',
                        response: value.rent,
                        relevanceResponseCRC: value.rentCRCrelevenceResponse,
                        relevanceRemarksCRC: value.rentCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[1].fields.push(houseAddressArr);
                }

                if (value.propTax !== null) {
                    houseAddressArr = {
                        fieldName: 'Propertytaxpaid',
                        response: value.propTax,
                        relevanceResponseCRC: value.propTaxCRCrelevenceResponse,
                        relevanceRemarksCRC: value.propTaxCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[1].fields.push(houseAddressArr);
                }
                if (value.tenantName !== null) {
                    houseAddressArr = {
                        fieldName: 'tenantName',
                        response: value.tenantName,
                        relevanceResponseCRC: value.tenantNameCRCrelevenceResponse,
                        relevanceRemarksCRC: value.tenantNameCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[1].fields.push(houseAddressArr);
                }
                if (value.pan !== null) {
                    houseAddressArr = {
                        fieldName: 'pan',
                        response: value.pan,
                        relevanceResponseCRC: value.panCRCrelevenceResponse,
                        relevanceRemarksCRC: value.panCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[1].fields.push(houseAddressArr);
                }
                if (value.housepurposeType !== null) {
                    houseAddressArr = {
                        fieldName: 'housepurposeType',
                        response: value.housepurposeType,
                        relevanceResponseCRC: value.housepurposeTypeCRCrelevenceResponse,
                        relevanceRemarksCRC: value.housepurposeTypeCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[1].fields.push(houseAddressArr);
                }
                if (value.upload !== null) {
                    houseAddressArr = {
                        fieldName: 'rentUpload',
                        response: value.rentUpload,
                        relevanceResponseCRC: '',
                        relevanceRemarksCRC: '',
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[1].fields.push(houseAddressArr);
                }
                if (value.TDSdeductedinrentType !== null) {
                    houseAddressArr = {
                        fieldName: 'TDSdeductedinrentType',
                        response: value.TDSdeductedinrentType,
                        relevanceResponseCRC: value.TDSdeductedinrentTypeCRCrelevenceResponse,
                        relevanceRemarksCRC: value.TDSdeductedinrentTypeCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[1].fields.push(houseAddressArr);
                }
                if (value.upload !== null) {
                    houseAddressArr = {
                        fieldName: 'propertyUpload',
                        response: value.propertyUpload,
                        relevanceResponseCRC: '',
                        relevanceRemarksCRC: '',
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[1].fields.push(houseAddressArr);
                }
                if (value.haveyoutakenanyhousingloanType !== null) {
                    houseAddressArr = {
                        fieldName: 'haveyoutakenanyhousingloanType',
                        response: value.haveyoutakenanyhousingloanType,
                        relevanceResponseCRC: value.haveyoutakenanyhousingloanTypeCRCrelevenceResponse,
                        relevanceRemarksCRC: value.haveyoutakenanyhousingloanTypeCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[1].fields.push(houseAddressArr);
                }
                if (value.propertyCoOwnedType !== null) {
                    houseAddressArr = {
                        fieldName: 'propertyCoOwnedType',
                        response: value.propertyCoOwnedType,
                        relevanceResponseCRC: '',
                        relevanceRemarksCRC: '',
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[1].fields.push(houseAddressArr);
                }
                if (value.coowner !== null || value.coowner.length > 0 || value.coowner !== undefined) {
                    let coOwnerArrayFields = [];
                    value.coowner.map((coOwnerValue, index) => {
                        if (coOwnerValue.coownerName !== null) {
                            let coOwnerArray = {
                                sectionText: 'coownerName-' + housePropertyIndex,
                                response: coOwnerValue.coownerName,
                                relevanceResponseCRC: coOwnerValue.coownerNameCRCrelevenceResponse,
                                relevanceRemarksCRC: coOwnerValue.coownerNameCRCrelevenceRemarks,
                                relevanceResponseAM: '',
                                relevanceRemarksAM: '',
                                autoPopulate: true,
                                coownerID: housePropertyIndex,
                            };
                            data.checklistJson.checklistL1.questions[2].subQuestion[1].subSubQuestions.push(coOwnerArray);
                        }
                        if (coOwnerValue.coownerPan !== null) {
                            let coOwnerArray = {
                                sectionText: 'coownerPan-' + housePropertyIndex,
                                response: coOwnerValue.coownerPan,
                                relevanceResponseCRC: coOwnerValue.coownerPanCRCrelevenceResponse,
                                relevanceRemarksCRC: coOwnerValue.coownerPanCRCrelevenceRemarks,
                                relevanceResponseAM: '',
                                relevanceRemarksAM: '',
                                autoPopulate: true,
                                coownerID: housePropertyIndex,
                            };
                            data.checklistJson.checklistL1.questions[2].subQuestion[1].subSubQuestions.push(coOwnerArray);
                        }
                        if (coOwnerValue.share !== null) {
                            let coOwnerArray = {
                                sectionText: 'share-' + housePropertyIndex,
                                response: coOwnerValue.share,
                                relevanceResponseCRC: coOwnerValue.shareCRCrelevenceResponse,
                                relevanceRemarksCRC: coOwnerValue.shareCRCrelevenceRemarks,
                                relevanceResponseAM: '',
                                relevanceRemarksAM: '',
                                autoPopulate: true,
                                coownerID: housePropertyIndex,
                            };
                            data.checklistJson.checklistL1.questions[2].subQuestion[1].subSubQuestions.push(coOwnerArray);
                        }
                    });
                }
                if (value.upload !== null) {
                    houseAddressArr = {
                        fieldName: 'loanUpload',
                        response: value.loanUpload,
                        relevanceResponseCRC: value.loanUploadCRCrelevenceResponse,
                        relevanceRemarksCRC: value.loanUploadCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[1].fields.push(houseAddressArr);
                }
                if (value.upload !== null) {
                    console.log('Value3100', value);
                    houseAddressArr = {
                        fieldName: 'TDSUpload',
                        response: value.TDSUpload,
                        relevanceResponseCRC: value.TDSUploadCRCrelevenceResponse,
                        relevanceRemarksCRC: value.TDSUploadCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[1].fields.push(houseAddressArr);
                }
                return true;
            });
        }

        if (values.tallyYes !== null && values.tallyYes !== undefined) {
            values.tallyYes.map((value, index) => {
                let tallyYesArr = {};
                if (value.nameFirm !== null) {
                    tallyYesArr = {
                        fieldName: 'nameFirm',
                        response: value.nameFirm,
                        relevanceResponseCRC: value.nameFirmCRCrelevenceResponse,
                        relevanceRemarksCRC: value.nameFirmCRCrelevenceRemarks,
                        relevanceResponseAM: 'Relevant',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields.push(tallyYesArr);
                }

                if (value.panNoFirm !== null) {
                    tallyYesArr = {
                        fieldName: 'panNoFirm',
                        response: value.panNoFirm,
                        relevanceResponseCRC: value.panNoFirmCRCrelevenceResponse,
                        relevanceRemarksCRC: value.panNoFirmCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields.push(tallyYesArr);
                }

                if (value.remunRec !== null) {
                    tallyYesArr = {
                        fieldName: 'remunRec',
                        response: value.remunRec,
                        relevanceResponseCRC: value.remunRecCRCrelevenceResponse,
                        relevanceRemarksCRC: value.remunRecCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields.push(tallyYesArr);
                }
                if (value.amtInt !== null) {
                    tallyYesArr = {
                        fieldName: 'amtInt',
                        response: value.amtInt,
                        relevanceResponseCRC: value.amtIntCRCrelevenceResponse,
                        relevanceRemarksCRC: value.amtIntCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields.push(tallyYesArr);
                }
                if (value.shareProfit !== null) {
                    tallyYesArr = {
                        fieldName: 'shareProfit',
                        response: value.shareProfit,
                        relevanceResponseCRC: value.shareProfitCRCrelevenceResponse,
                        relevanceRemarksCRC: value.shareProfitCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields.push(tallyYesArr);
                }
                if (value.shareProfitRs !== null) {
                    tallyYesArr = {
                        fieldName: 'shareProfitRs',
                        response: value.shareProfitRs,
                        relevanceResponseCRC: value.shareProfitRsCRCrelevenceResponse,
                        relevanceRemarksCRC: value.shareProfitRsCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields.push(tallyYesArr);
                }
                if (value.firmAudit !== null) {
                    tallyYesArr = {
                        fieldName: 'firmAudit',
                        response: value.firmAudit,
                        relevanceResponseCRC: value.firmAuditCRCrelevenceResponse,
                        relevanceRemarksCRC: value.firmAuditCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields.push(tallyYesArr);
                }
                if (value.transferPrice !== null) {
                    tallyYesArr = {
                        fieldName: 'transferPrice',
                        response: value.transferPrice,
                        relevanceResponseCRC: value.transferPriceCRCrelevenceResponse,
                        relevanceRemarksCRC: value.transferPriceCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields.push(tallyYesArr);
                }
                if (value.balance !== null) {
                    tallyYesArr = {
                        fieldName: 'balance',
                        response: value.balance,
                        relevanceResponseCRC: value.balanceCRCrelevenceResponse,
                        relevanceRemarksCRC: value.balanceCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields.push(tallyYesArr);
                }
                return true;
            });
        }

        if (values.investment1 !== null && values.investment1 !== undefined) {
            values.investment1.map((value, index) => {
                //console.log('investment..value', value);
                let investmentArr = {};
                if (value.investmentDetails !== null) {
                    investmentArr = {
                        fieldName: 'investmentDetails',
                        response: value.investmentDetails,
                        relevanceResponseCRC: value.investmentDetailsCRCRelevenceResponse,
                        relevanceRemarksCRC: value.investmentDetailsCRCRelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[6].subSubQuestions[0].fields.push(investmentArr);
                }
                if (value.investmentAmt !== null) {
                    investmentArr = {
                        fieldName: 'investmentAmt',
                        response: value.investmentAmt,
                        relevanceResponseCRC: value.investmentAmtCRCRelevenceResponse,
                        relevanceRemarksCRC: value.investmentAmtCRCRelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[6].subSubQuestions[0].fields.push(investmentArr);
                }
                if (value.invAmtUpload !== null) {
                    investmentArr = {
                        fieldName: 'invAmtUpload',
                        response: value.invAmtUpload,
                        relevanceResponseCRC: value.invAmtUploadCRCRelevenceResponse,
                        relevanceRemarksCRC: value.invAmtUploadCRCRelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[6].subSubQuestions[0].fields.push(investmentArr);
                }
                return true;
            });
        }

        if (values.donation1 !== null && values.donation1 !== undefined) {
            values.donation1.map((value, index) => {
                let donationArr = {};
                if (value.donationDetails !== null) {
                    donationArr = {
                        fieldName: 'donationDetails',
                        response: value.donationDetails,
                        relevanceResponseCRC: value.donationDetailsCRCRelevenceResponse,
                        relevanceRemarksCRC: value.donationDetailsCRCRelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[6].subSubQuestions[1].fields.push(donationArr);
                }

                if (value.donationAmt !== null) {
                    donationArr = {
                        fieldName: 'donationAmt',
                        response: value.donationAmt,
                        relevanceResponseCRC: value.donationAmountCRCRelevenceResponse,
                        relevanceRemarksCRC: value.donationAmountCRCRelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[6].subSubQuestions[1].fields.push(donationArr);
                }
                if (value.donationAmtUpload !== null) {
                    donationArr = {
                        fieldName: 'donationAmtUpload',
                        response: value.donationAmtUpload,
                        relevanceResponseCRC: value.donationAmtUploadCRCRelevenceResponse,
                        relevanceRemarksCRC: value.donationAmtUploadCRCRelevenceRemarks,
                        relevanceResponseAM: 'Relevant',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[6].subSubQuestions[1].fields.push(donationArr);
                }
                return true;
            });
        }

        console.log('SAVE =>>>>> data', data);
        console.log('userType3351', userType);

        if (userType === 'Ultimate Client') {
            const res = yield call(axios, `/api/itr/checklist/save-response/${tennantnameValue}`, {
                method: 'put',
                baseURL: `${CommonConfig.dev.baseUrl1}`,
                data: data,
                headers: {
                    Authorization: bearerToken,
                },
            });
            const creategeninfosave = res.data;
            yield put({ type: CreateGenInfoActionTypes.SUCCESS, payload: creategeninfosave });
        } else if (userType === 'ITeC AM and above') {
            const resAM = yield call(axios, `/api/itr/checklist/am-save-relevance/${imcNameSelected}`, {
                method: 'put',
                baseURL: `${CommonConfig.dev.baseUrl1}`,
                data: data,
                headers: {
                    Authorization: bearerToken,
                },
            });
            const creategeninfosave = resAM.data;
            yield put({ type: CreateGenInfoActionTypes.SUCCESS, payload: creategeninfosave });

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

            if (statusid === 5) {
                const resAML2 = yield call(axios, `/api/itr/checklist/creation/${imcNameSelected}`, {
                    method: 'put',
                    baseURL: `${CommonConfig.dev.baseUrl1}`,
                    data: data,
                    headers: {
                        Authorization: bearerToken,
                    },
                });
                const creategeninfosave = resAML2.data;
                yield put({ type: CreateGenInfoActionTypes.SUCCESS, payload: creategeninfosave });
            }
        } else if (userType === 'ITeC Team') {
            const resCRC = yield call(axios, `api/itr/checklist/crc-save-relevance/${imcNameSelected}`, {
                method: 'put',
                baseURL: `${CommonConfig.dev.baseUrl1}`,
                data: data,
                headers: {
                    Authorization: bearerToken,
                },
            });
            const creategeninfosave = resCRC.data;
            yield put({ type: CreateGenInfoActionTypes.SUCCESS, payload: creategeninfosave });
        }
    } catch (e) {
        const errorMessage = e.response;
        yield put({ type: CreateGenInfoActionTypes.FAILED, error: errorMessage });
    }
}

function* handleGenInfoRequestSubmit(action) {
    try {
        const { params, bearerToken, serviceIdValue, usertype, statusIDValue, tennantnameValue, imcNameSelected } = action.payload;
        const userType = usertype;
        const values = params;

        console.log('SUBMIT =>>>>> params', params);
        // const values = params;
        // const userType = usertype;
        // const statusid = statusIDValue;
        console.log('SUBMIT ==----->values', values);

        const data = {
            serviceId: serviceIdValue,
            remarks: 'Remarks',
            checklistJson: {
                checklistL1: {
                    relevantFlag: false,
                    questions: [
                        {
                            sectionText: 'General Information?',
                            relevanceResponse: '',
                            relevanceRemarks: '',
                            relevantFlag: false,
                            autoPopulate: true,
                            fields: [
                                {
                                    fieldName: 'firstName',
                                    response: values.firstName,
                                    relevanceResponseCRC: values.firstnameRelevance,
                                    relevanceRemarksCRC: values.firstnameRelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'lastName',
                                    response: values.lastName,
                                    relevanceResponseCRC: values.lastnameRelevance,
                                    relevanceRemarksCRC: values.lastnameRelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'fatherNamePan',
                                    response: values.fatherNamePan,
                                    relevanceResponseCRC: values.fatherNamePanRelevance,
                                    relevanceRemarksCRC: values.fatherNamePanRelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'pan',
                                    response: values.pan,
                                    relevanceResponseCRC: values.panRelevance,
                                    relevanceRemarksCRC: values.panRelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'address1',
                                    response: values.address1,
                                    relevanceResponseCRC: values.address1Relevance,
                                    relevanceRemarksCRC: values.address1RelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'address2',
                                    response: values.address2,
                                    relevanceResponseCRC: values.address2Relevance,
                                    relevanceRemarksCRC: values.address2RelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'city',
                                    response: values.city,
                                    relevanceResponseCRC: values.cityRelevance,
                                    relevanceRemarksCRC: values.cityRelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'state',
                                    response: values.state,
                                    relevanceResponseCRC: values.stateRelevance,
                                    relevanceRemarksCRC: values.stateRelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'country',
                                    response: values.country,
                                    relevanceResponseCRC: values.countryRelevance,
                                    relevanceRemarksCRC: values.countryRelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'pin',
                                    response: values.pin,
                                    relevanceResponseCRC: values.pinRelevance,
                                    relevanceRemarksCRC: values.pinRelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'dob',
                                    response: values.dob,
                                    relevanceResponseCRC: values.dobRelevance,
                                    relevanceRemarksCRC: values.dobRelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'mobileNo',
                                    response: values.mobileNo,
                                    relevanceResponseCRC: values.mobileNoRelevance,
                                    relevanceRemarksCRC: values.mobileNoRelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'emailaddress',
                                    response: values.emailaddress,
                                    relevanceResponseCRC: values.emailaddressRelevance,
                                    relevanceRemarksCRC: values.emailaddressRelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'passport',
                                    response: values.passport,
                                    relevanceResponseCRC: values.passportRelevance,
                                    relevanceRemarksCRC: values.passportRelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'govIDType',
                                    response: values.govIDType,
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'govIDNumber',
                                    response: values.govIDNumber,
                                    relevanceResponseCRC: values.govIDNumberRelevance,
                                    relevanceRemarksCRC: values.govIDNumberRelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'Upload',
                                    response: values.URLValue,
                                    relevanceResponseCRC: values.URLValueRelevance,
                                    relevanceRemarksCRC: values.URLValueRelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'radiodata',
                                    response: values.radiodata,
                                    relevanceResponseCRC: values.radioDataRelevance,
                                    relevanceRemarksCRC: values.radioDataRelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'GSTIN',
                                    response: values.GSTIN,
                                    relevanceResponseCRC: values.gstinRelevance,
                                    relevanceRemarksCRC: values.gstinRelevanceRemarks,
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'panFile',
                                    response: values.panFile,
                                    relevanceResponseCRC: '',
                                    relevanceRemarksCRC: '',
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'aadharFile',
                                    response: values.aadharFile,
                                    relevanceResponseCRC: '',
                                    relevanceRemarksCRC: '',
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'enrollmentFile',
                                    response: values.enrollmentFile,
                                    relevanceResponseCRC: '',
                                    relevanceRemarksCRC: '',
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'gstFile',
                                    response: values.gstFile,
                                    relevanceResponseCRC: '',
                                    relevanceRemarksCRC: '',
                                    autoPopulate: true,
                                },
                            ],
                        },
                        {
                            sectionText: 'Bank Details',
                            relevanceResponse: '',
                            relevanceRemarks: '',
                            relevantFlag: false,
                            autoPopulate: true,
                            fields: [],
                        },
                        {
                            sectionText: 'What are the different sources of income that you have?',
                            relevanceResponseCRC: 'Relevant',
                            relevanceRemarksCRC: '',
                            relevanceResponseAM: 'Relevant',
                            relevanceRemarksAM: '',
                            relevantFlag: false,
                            autoPopulate: true,
                            subQuestion: [
                                {
                                    sectionText: 'Salary',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    subSubQuestions: [
                                        {
                                            sectionText: 'SalaryTab',
                                            response: '',
                                            relevanceResponseCRC: 'Relevant',
                                            relevanceRemarksCRC: '',
                                            relevanceResponseAM: 'Relevant',
                                            relevanceRemarksAM: '',
                                            fields: [
                                                {
                                                    fieldName: 'salaryradiodata',
                                                    response: values.salaryradiodata,
                                                    relevanceResponseCRC: 'Relevant',
                                                    relevanceRemarksCRC: '',
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                    autoPopulate: true,
                                                },
                                                {
                                                    fieldName: 'Name of the Employer',
                                                    response: values.nameEmployer,
                                                    relevanceResponseCRC: values.nameEmployerCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.nameEmployerCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                    autoPopulate: true,
                                                },
                                                {
                                                    fieldName: 'Upload Form16',
                                                    response: values.url,
                                                    relevanceResponseCRC: values.nameEmployerCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.nameEmployerCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                    autoPopulate: true,
                                                },
                                            ],
                                        },
                                        {
                                            sectionText: 'investment',
                                            response: '',
                                            relevanceResponseCRC: 'Relevant',
                                            relevanceRemarksCRC: '',
                                            relevanceResponseAM: 'Relevant',
                                            relevanceRemarksAM: '',
                                            fields: [],
                                        },
                                        {
                                            sectionText: 'donation',
                                            response: '',
                                            relevanceResponseCRC: 'Relevant',
                                            relevanceRemarksCRC: '',
                                            relevanceResponseAM: 'Relevant',
                                            relevanceRemarksAM: '',
                                            fields: [],
                                        },
                                    ],
                                },
                                {
                                    sectionText: 'House Property',
                                    response: values.incomeFromHouseProperty,
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                    subSubQuestions: [],
                                },
                                {
                                    sectionText: 'Business or Profession',
                                    response: values.incomeFromBusinessProfesion,
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    subSubQuestions: [
                                        {
                                            sectionText: 'BusinessTab',
                                            response: '',
                                            relevanceResponseCRC: 'Relevant',
                                            relevanceRemarksCRC: '',
                                            relevanceResponseAM: 'Relevant',
                                            relevanceRemarksAM: '',
                                            fields: [
                                                {
                                                    fieldName: 'natureBusiness',
                                                    response: values.natureBusiness,
                                                    relevanceResponseCRC: values.natureBusinessCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.natureBusinessCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                    autoPopulate: true,
                                                },
                                                {
                                                    fieldName: 'busProfincomeType',
                                                    response: values.busProfincomeType,
                                                    relevanceResponseCRC: values.busProfincomeTypeCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.busProfincomeTypeCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'totalReceipts',
                                                    response: values.totalReceipts,
                                                    relevanceResponseCRC: values.totalReceiptsCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.totalReceiptsCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'totalExpenses',
                                                    response: values.totalExpenses,
                                                    relevanceResponseCRC: values.totalExpensesCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.totalExpensesCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'gstReturnDoc',
                                                    response: values.gstReturnDoc,
                                                    relevanceResponseCRC: values.gstReturnDocCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.gstReturnDocCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'otherStatement',
                                                    response: values.otherStatement,
                                                    relevanceResponseCRC: values.otherStatementCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.otherStatementCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'busProfType',
                                                    response: values.busProfType,
                                                    relevanceResponseCRC: values.busProfTypeCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.busProfTypeCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'userIDtally',
                                                    response: values.userIDtally,
                                                    relevanceResponseCRC: values.userIDtallyCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.userIDtallyCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'passwordtally',
                                                    response: values.passwordtally,
                                                    relevanceResponseCRC: values.passwordtallyCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.passwordtallyCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'uploadTally',
                                                    response: values.uploadTally,
                                                    relevanceResponseCRC: values.uploadTallyCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.uploadTallyCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'userIDZoho',
                                                    response: values.userIDZoho,
                                                    relevanceResponseCRC: values.userIDZohoCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.userIDZohoCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'passwordZoho',
                                                    response: values.passwordZoho,
                                                    relevanceResponseCRC: values.passwordZohoCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.passwordZohoCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'accountDetails',
                                                    response: values.accountDetails,
                                                    relevanceResponseCRC: values.accountDetailsCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.accountDetailsCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'partnershipradio',
                                                    response: values.partnershipradio,
                                                    relevanceResponseCRC: values.partnershipradioCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.partnershipradioCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'totalReceiptsUpload',
                                                    response: values.totalReceiptsUpload,
                                                    relevanceResponseCRC: values.totalReceiptsUploadCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.totalReceiptsUploadCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'totalExpensesUpload',
                                                    response: values.totalExpensesUpload,
                                                    relevanceResponseCRC: values.totalExpensesUploadCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.totalExpensesUploadCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'gstUpload',
                                                    response: values.gstUpload,
                                                    relevanceResponseCRC: values.gstUploadCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.gstUploadCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'statementUpload',
                                                    response: values.statementUpload,
                                                    relevanceResponseCRC: values.statementUploadCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.statementUploadCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'userIDQB',
                                                    response: values.userIDQB,
                                                    relevanceResponseCRC: values.userIDQBCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.userIDQBCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                                {
                                                    fieldName: 'passwordQB',
                                                    response: values.passwordQB,
                                                    relevanceResponseCRC: values.passwordQBCRCrelevenceResponse,
                                                    relevanceRemarksCRC: values.passwordQBCRCrelevenceRemarks,
                                                    relevanceResponseAM: 'Relevant',
                                                    relevanceRemarksAM: '',
                                                },
                                            ],
                                        },
                                        {
                                            sectionText: 'TallyYes',
                                            response: '',
                                            relevanceResponseCRC: 'Relevant',
                                            relevanceRemarksCRC: '',
                                            relevanceResponseAM: 'Relevant',
                                            relevanceRemarksAM: '',
                                            fields: [],
                                        },
                                    ],
                                },
                                {
                                    sectionText: 'Capital Gain',
                                    response: values.soldAnyAsset,
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                },
                                {
                                    sectionText: 'Others Sources',
                                    response: values.explicitlyUncoveredIncom,
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    subSubQuestions: [
                                        {
                                            fieldName: 'divident',
                                            response: '',
                                            relevanceResponseCRC: 'Relevant',
                                            relevanceRemarksCRC: '',
                                            relevanceResponseAM: 'Relevant',
                                            relevanceRemarksAM: '',
                                            fields: [],
                                        },
                                        {
                                            fieldName: 'fd',
                                            response: '',
                                            relevanceResponseCRC: 'Relevant',
                                            relevanceRemarksCRC: '',
                                            relevanceResponseAM: 'Relevant',
                                            relevanceRemarksAM: '',
                                            fields: [],
                                        },
                                        {
                                            fieldName: 'othersources',
                                            response: '',
                                            relevanceResponseCRC: 'Relevant',
                                            relevanceRemarksCRC: '',
                                            relevanceResponseAM: 'Relevant',
                                            relevanceRemarksAM: '',
                                            fields: [],
                                        },
                                    ],
                                },
                                {
                                    sectionText: 'Agriculture Income',
                                    response: values.agricultureIncome,
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                    //     {
                                    //         fieldName: 'agricultureName',
                                    //         response: values.agricultureName,
                                    //         relevanceResponseCRC: values.agricultureNameCRCrelevenceResponse,
                                    //         relevanceRemarksCRC: values.agricultureNameCRCrelevenceRemarks,
                                    //         relevanceResponseAM: 'Relevant',
                                    //         relevanceRemarksAM: '',
                                    //     },
                                    //     {
                                    //         fieldName: 'agriAmount',
                                    //         response: values.agriAmount,
                                    //         relevanceResponseCRC: values.agriAmountCRCrelevenceResponse,
                                    //         relevanceRemarksCRC: values.agriAmountCRCrelevenceRemarks,
                                    //         relevanceResponseAM: 'Relevant',
                                    //         relevanceRemarksAM: '',
                                    //     },
                                    //     {
                                    //         fieldName: 'agriReceipt',
                                    //         response: values.agriReceipt,
                                    //         relevanceResponseCRC: values.agriReceiptCRCrelevenceResponse,
                                    //         relevanceRemarksCRC: values.agriReceiptCRCrelevenceRemarks,
                                    //         relevanceResponseAM: 'Relevant',
                                    //         relevanceRemarksAM: '',
                                    //     },
                                    //     {
                                    //         fieldName: 'agriExpenses',
                                    //         response: values.agriExpenses,
                                    //         relevanceResponseCRC: values.agriExpensesCRCrelevenceResponse,
                                    //         relevanceRemarksCRC: values.agriExpensesCRCrelevenceRemarks,
                                    //         relevanceResponseAM: 'Relevant',
                                    //         relevanceRemarksAM: '',
                                    //     },
                                    //     {
                                    //         fieldName: 'agriReceiptUpload',
                                    //         response: values.agriReceiptUpload,
                                    //         relevanceResponseCRC: values.agriReceiptUploadCRCrelevenceResponse,
                                    //         relevanceRemarksCRC: values.agriReceiptUploadCRCrelevenceRemarks,
                                    //         relevanceResponseAM: 'Relevant',
                                    //         relevanceRemarksAM: '',
                                    //     },
                                    //     {
                                    //         fieldName: 'agriExpensesUpload',
                                    //         response: values.agriExpensesUpload,
                                    //         relevanceResponseCRC: values.agriExpensesUploadCRCrelevenceResponse,
                                    //         relevanceRemarksCRC: values.agriExpensesUploadCRCrelevenceRemarks,
                                    //         relevanceResponseAM: 'Relevant',
                                    //         relevanceRemarksAM: '',
                                    //     },
                                    // ],
                                },
                                {
                                    sectionText: 'Deductions',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    subSubQuestions: [
                                        {
                                            sectionText: 'investment1',
                                            response: '',
                                            relevanceResponseCRC: 'Relevant',
                                            relevanceRemarksCRC: '',
                                            relevanceResponseAM: 'Relevant',
                                            relevanceRemarksAM: '',
                                            fields: [],
                                        },
                                        {
                                            sectionText: 'donation1',
                                            response: '',
                                            relevanceResponseCRC: 'Relevant',
                                            relevanceRemarksCRC: '',
                                            relevanceResponseAM: 'Relevant',
                                            relevanceRemarksAM: '',
                                            fields: [],
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            sectionText: 'Income tax login password',
                            relevanceResponse: '',
                            relevanceRemarks: '',
                            relevantFlag: false,
                            autoPopulate: true,
                            fields: [
                                {
                                    fieldName: 'incomeTaxType',
                                    response: values.incomeTaxType,
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    autoPopulate: true,
                                },
                                {
                                    fieldName: 'User ID',
                                    response: values.incomeUserId,
                                    relevanceResponseCRC: values.userIdRelevance,
                                    relevanceRemarksCRC: values.userIdRelevanceRemarks,
                                },
                                {
                                    fieldName: 'Password',
                                    response: values.incomePassword,
                                    relevanceResponseCRC: values.passwordRelevance,
                                    relevanceRemarksCRC: values.passwordRelevanceRemarks,
                                },
                            ],
                        },
                        {
                            sectionText: 'Have you travelled outside india during the previous year?',
                            relevanceResponse: '',
                            relevanceRemarks: '',
                            relevantFlag: false,
                            autoPopulate: true,
                            fields: [
                                {
                                    fieldName: 'traveloutsideType',
                                    response: values.traveloutsideType,
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    autoPopulate: true,
                                },
                            ],
                            subQuestion: [
                                {
                                    sectionText: 'traveloutside',
                                    relevanceResponse: '',
                                    relevanceRemarks: '',
                                    relevantFlag: false,
                                    autoPopulate: true,
                                    fields: [],
                                },
                            ],
                        },
                        {
                            sectionText: 'Directory Company?',
                            relevanceResponse: '',
                            relevanceRemarks: '',
                            relevantFlag: false,
                            autoPopulate: true,
                            fields: [
                                {
                                    fieldName: 'directorType',
                                    response: values.directorType,
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    autoPopulate: true,
                                },
                            ],
                            subQuestion: [
                                {
                                    sectionText: 'directorCompany',
                                    relevanceResponse: '',
                                    relevanceRemarks: '',
                                    relevantFlag: false,
                                    autoPopulate: true,
                                    fields: [],
                                },
                            ],
                        },
                        {
                            sectionText: 'Do you have income/assets from sources outside india?',
                            relevanceResponse: '',
                            relevanceRemarks: '',
                            relevantFlag: false,
                            autoPopulate: true,
                            subQuestion: [
                                {
                                    sectionText: 'Details of Income accuring or arising outside India',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    subSubQuestions: [
                                        {
                                            sectionText: 'assetHome',
                                            response: '',
                                            relevanceResponseCRC: 'Relevant',
                                            relevanceRemarksCRC: '',
                                            relevanceResponseAM: 'Relevant',
                                            relevanceRemarksAM: '',
                                            fields: [],
                                        },
                                        {
                                            sectionText: 'assetNature',
                                            response: '',
                                            relevanceResponseCRC: 'Relevant',
                                            relevanceRemarksCRC: '',
                                            relevanceResponseAM: 'Relevant',
                                            relevanceRemarksAM: '',
                                            fields: [],
                                        },
                                    ],
                                },
                                {
                                    sectionText: 'Details of financial interest in any entity',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                },
                                {
                                    sectionText: 'Details of immovable property',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                },
                                {
                                    sectionText: 'Details of any others capital asset held at any time during the previous year',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                },
                                {
                                    sectionText:
                                        'Details of accounts in which you are a signing authority, which is not part of any of above list',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                },
                                {
                                    sectionText: 'Details of Trust created outside India, in which you are a trustee ',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                },
                                {
                                    sectionText:
                                        'Details of any other income derived from any other source outside India which is not included above',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                },
                                {
                                    sectionText:
                                        'Details of foreign depository accounts held (including any beneficial interest) at any time during the year',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                },
                                {
                                    sectionText:
                                        'Details of foreign custodial accounts held (including any beneficial interest) at any time during the year',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                },
                                {
                                    sectionText:
                                        'Details of foreign equity and debt interest held (including any beneficial interest) in any entity at any time during the year',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                },
                                {
                                    sectionText:
                                        'Details of foreign cash value insurance contract or annuity contract held (including any beneficial interest) at any time during the year',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                },
                                {
                                    sectionText: 'Foreign Asset Radio',
                                    relevanceResponse: '',
                                    relevanceRemarks: '',
                                    relevantFlag: false,
                                    autoPopulate: true,
                                    fields: [
                                        {
                                            fieldName: 'assetradio',
                                            response: values.assetradio,
                                            relevanceResponseCRC: 'Relevant',
                                            relevanceRemarksCRC: '',
                                            relevanceResponseAM: 'Relevant',
                                            relevanceRemarksAM: '',
                                            autoPopulate: true,
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            sectionText: 'Does your total income exceed Rs 50Lakhs?',
                            relevanceResponse: '',
                            relevanceRemarks: '',
                            relevantFlag: false,
                            autoPopulate: true,
                            subQuestion: [
                                {
                                    sectionText: 'Details of immovable assets',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                },
                                {
                                    sectionText: 'Details of movable seat',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                },
                                {
                                    sectionText: 'Whether you have held unlisted equity shares at any time during the previous year',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                },
                                {
                                    sectionText:
                                        'Interest held in the assets of a firm or association of persons (AOP) as a partner or member thereof',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                },
                                {
                                    sectionText: 'Liabilities(if any) relating to the above assets at A,B and C',
                                    response: '',
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                },
                                {
                                    sectionText: 'Total income Radio',
                                    relevanceResponse: '',
                                    relevanceRemarks: '',
                                    relevantFlag: false,
                                    autoPopulate: true,
                                    fields: [
                                        {
                                            fieldName: 'totalincomeradio',
                                            response: values.totalincomeradio,
                                            relevanceResponseCRC: 'Relevant',
                                            relevanceRemarksCRC: '',
                                            relevanceResponseAM: 'Relevant',
                                            relevanceRemarksAM: '',
                                            autoPopulate: true,
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            sectionText: 'additionalQuestion',
                            relevanceResponse: '',
                            relevanceRemarks: '',
                            relevantFlag: false,
                            autoPopulate: true,
                            subQuestion: [
                                {
                                    sectionText: 'additionalQuestion',
                                    response: '',
                                    isAttachmentRequired: true,
                                    relevantFlag: true,
                                    autoPopulate: true,
                                    relevanceResponseCRC: 'Relevant',
                                    relevanceRemarksCRC: '',
                                    relevanceResponseAM: 'Relevant',
                                    relevanceRemarksAM: '',
                                    fields: [],
                                },
                            ],
                        },
                    ],
                },
            },
        };

        if (values.additionalQue !== null && values.additionalQue !== undefined) {
            values.additionalQue.map((value, index) => {
                //console.log('value.....', value);
                let additionalQueArr = {};
                if (value !== null) {
                    additionalQueArr = {
                        fieldName: 'response',
                        response: value.response,
                        relevanceRemarksAM: value.questionId,
                        relevanceResponseAM: value.questionText,
                        relevanceRemarksCRC: value.relevanceRemarksCRC,
                        relevanceResponseCRC: value.relevanceResponseCRC,
                    };
                    data.checklistJson.checklistL1.questions[8].subQuestion[0].fields.push(additionalQueArr);
                }
                return true;
            });
        }

        // if (values.additionalQue !== null && values.additionalQue !== undefined) {
        //     values.additionalQue.map((value, index) => {
        //         ////console.log('value.....', value);
        //         let additionalQueArr = {};
        //         if (value !== null) {
        //             additionalQueArr = {
        //                 fieldName: 'response',
        //                 response: value.response,
        //                 relevanceRemarksAM: value.questionId,
        //                 relevanceResponseAM: value.questionText,
        //                 relevanceRemarksCRC: value.relevanceRemarksCRC,
        //                 relevanceResponseCRC: value.relevanceResponseCRC,
        //             };
        //             data.checklistJson.checklistL1.questions[8].subQuestion[0].fields.push(additionalQueArr);
        //         }
        //         return true;
        //     });
        // }

        if (values.travelOutside !== null && values.travelOutside !== undefined) {
            values.travelOutside.map((value, index) => {
                //console.log('index.....', index);
                let travelOutsideArr = {};
                if (value.year !== null) {
                    travelOutsideArr = {
                        fieldName: 'year',
                        response: value.year,
                        relevanceResponseCRC: value.yearRelevance,
                        relevanceRemarksCRC: value.yearRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[4].subQuestion[0].fields.push(travelOutsideArr);
                }

                if (value.daysIndia !== null) {
                    travelOutsideArr = {
                        fieldName: 'daysIndia',
                        response: value.daysIndia,
                        relevanceResponseCRC: value.daysIndiaRelevance,
                        relevanceRemarksCRC: value.daysIndiaRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[4].subQuestion[0].fields.push(travelOutsideArr);
                }

                return true;
            });
        }

        if (values.directorCompany !== null && values.directorCompany !== undefined) {
            values.directorCompany.map((value, index) => {
                //console.log('index.....', index);
                let directorCompanyArr = {};
                if (value.companyName !== null) {
                    directorCompanyArr = {
                        fieldName: 'companyName',
                        response: value.companyName,
                        relevanceResponseCRC: value.companyNameRelevance,
                        relevanceRemarksCRC: value.companyNameRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[5].subQuestion[0].fields.push(directorCompanyArr);
                }

                if (value.panCompany !== null) {
                    directorCompanyArr = {
                        fieldName: 'panCompany',
                        response: value.panCompany,
                        relevanceResponseCRC: value.panCompanyRelevance,
                        relevanceRemarksCRC: value.panCompanyRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[5].subQuestion[0].fields.push(directorCompanyArr);
                }

                if (value.shares !== null) {
                    directorCompanyArr = {
                        fieldName: 'shares',
                        response: value.shares,
                        relevanceResponseCRC: value.sharesRelevance,
                        relevanceRemarksCRC: value.sharesRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[5].subQuestion[0].fields.push(directorCompanyArr);
                }

                if (value.din !== null) {
                    directorCompanyArr = {
                        fieldName: 'din',
                        response: value.din,
                        relevanceResponseCRC: value.compDinRelevance,
                        relevanceRemarksCRC: value.compDinRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[5].subQuestion[0].fields.push(directorCompanyArr);
                }

                return true;
            });
        }

        if (values.assetHome !== null && values.assetHome !== undefined) {
            values.assetHome.map((value, index) => {
                //console.log('index.....', index);
                let assetHomeArr = {};
                if (value.country !== null) {
                    assetHomeArr = {
                        fieldName: 'country',
                        response: value.country,
                        relevanceResponseCRC: value.country1Relevance,
                        relevanceRemarksCRC: value.country1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[0].subSubQuestions[0].fields.push(assetHomeArr);
                }

                if (value.tpin !== null) {
                    assetHomeArr = {
                        fieldName: 'tpin',
                        response: value.tpin,
                        relevanceResponseCRC: value.tpinRelevance,
                        relevanceRemarksCRC: value.tpinRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[0].subSubQuestions[0].fields.push(assetHomeArr);
                }

                if (value.salA !== null) {
                    assetHomeArr = {
                        fieldName: 'salA',
                        response: value.salA,
                        relevanceResponseCRC: value.salARelevance,
                        relevanceRemarksCRC: value.salARelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[0].subSubQuestions[0].fields.push(assetHomeArr);
                }

                if (value.salB !== null) {
                    assetHomeArr = {
                        fieldName: 'salB',
                        response: value.salB,
                        relevanceResponseCRC: value.salBRelevance,
                        relevanceRemarksCRC: value.salBRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[0].subSubQuestions[0].fields.push(assetHomeArr);
                }
                if (value.salC !== null) {
                    assetHomeArr = {
                        fieldName: 'salC',
                        response: value.salC,
                        relevanceResponseCRC: value.salCRelevance,
                        relevanceRemarksCRC: value.salCRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[0].subSubQuestions[0].fields.push(assetHomeArr);
                }
                if (value.salD !== null) {
                    assetHomeArr = {
                        fieldName: 'salD',
                        response: value.salD,
                        relevanceResponseCRC: value.salDRelevance,
                        relevanceRemarksCRC: value.salDRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[0].subSubQuestions[0].fields.push(assetHomeArr);
                }
                if (value.salE !== null) {
                    assetHomeArr = {
                        fieldName: 'salE',
                        response: value.salE,
                        relevanceResponseCRC: value.salERelevance,
                        relevanceRemarksCRC: value.salERelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[0].subSubQuestions[0].fields.push(assetHomeArr);
                }
                if (value.srcNature !== null) {
                    assetHomeArr = {
                        fieldName: 'srcNature',
                        response: value.srcNature,
                        relevanceResponseCRC: value.srcNatureRelevance,
                        relevanceRemarksCRC: value.srcNatureRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[0].subSubQuestions[0].fields.push(assetHomeArr);
                }
                if (value.totIncome !== null) {
                    assetHomeArr = {
                        fieldName: 'totIncome',
                        response: value.totIncome,
                        relevanceResponseCRC: value.totIncomeRelevance,
                        relevanceRemarksCRC: value.totIncomeRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[0].subSubQuestions[0].fields.push(assetHomeArr);
                }
                return true;
            });
        }

        if (values.assetNature !== null && values.assetNature !== undefined) {
            values.assetNature.map((value, index) => {
                //console.log('index.....', index);
                let assetNatureArr = {};
                if (value.incomeNature !== null) {
                    assetNatureArr = {
                        fieldName: 'incomeNature',
                        response: value.incomeNature,
                        relevanceResponseCRC: value.incomeNatureRelevance,
                        relevanceRemarksCRC: value.incomeNatureRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[0].subSubQuestions[1].fields.push(assetNatureArr);
                }

                if (value.foreignAmount !== null) {
                    assetNatureArr = {
                        fieldName: 'foreignAmount',
                        response: value.foreignAmount,
                        relevanceResponseCRC: value.foreignAmountRelevance,
                        relevanceRemarksCRC: value.foreignAmountRelevanceRemarks,
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[0].subSubQuestions[1].fields.push(assetNatureArr);
                }

                if (value.foreignTaxes !== null) {
                    assetNatureArr = {
                        fieldName: 'foreignTaxes',
                        response: value.foreignTaxes,
                        relevanceResponseCRC: value.foreignTaxesRelevance,
                        relevanceRemarksCRC: value.foreignTaxesRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[0].subSubQuestions[1].fields.push(assetNatureArr);
                }
                return true;
            });
        }

        if (values.client1 !== null && values.client1 !== undefined) {
            values.client1.map((value, index) => {
                //console.log('index.....', index);
                let client1Arr = {};
                if (value.country !== null) {
                    client1Arr = {
                        fieldName: 'country',
                        response: value.country,
                        relevanceResponseCRC: value.country1Relevance,
                        relevanceRemarksCRC: value.country1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[1].fields.push(client1Arr);
                }

                if (value.entityNature !== null) {
                    client1Arr = {
                        fieldName: 'entityNature',
                        response: value.entityNature,
                        relevanceResponseCRC: value.entityNature1Relevance,
                        relevanceRemarksCRC: value.entityNature1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[1].fields.push(client1Arr);
                }

                if (value.entityName !== null) {
                    client1Arr = {
                        fieldName: 'entityName',
                        response: value.entityName,
                        relevanceResponseCRC: value.entityName1Relevance,
                        relevanceRemarksCRC: value.entityName1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[1].fields.push(client1Arr);
                }
                if (value.entityAddress !== null) {
                    client1Arr = {
                        fieldName: 'entityAddress',
                        response: value.entityAddress,
                        relevanceResponseCRC: value.entityAddress1Relevance,
                        relevanceRemarksCRC: value.entityAddress1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[1].fields.push(client1Arr);
                }
                if (value.interestNature !== null) {
                    client1Arr = {
                        fieldName: 'interestNature',
                        response: value.interestNature,
                        relevanceResponseCRC: value.interestNature1Relevance,
                        relevanceRemarksCRC: value.interestNature1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[1].fields.push(client1Arr);
                }
                if (value.date !== null) {
                    client1Arr = {
                        fieldName: 'date',
                        response: value.date,
                        relevanceResponseCRC: value.date1Relevance,
                        relevanceRemarksCRC: value.date1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[1].fields.push(client1Arr);
                }
                if (value.totInvestment !== null) {
                    client1Arr = {
                        fieldName: 'totInvestment',
                        response: value.totInvestment,
                        relevanceResponseCRC: value.totInvestment1Relevance,
                        relevanceRemarksCRC: value.totInvestment1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[1].fields.push(client1Arr);
                }
                if (value.interestIncome !== null) {
                    client1Arr = {
                        fieldName: 'interestIncome',
                        response: value.interestIncome,
                        relevanceResponseCRC: value.interstIncome1Relevance,
                        relevanceRemarksCRC: value.interstIncome1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[1].fields.push(client1Arr);
                }
                if (value.incomeNature !== null) {
                    client1Arr = {
                        fieldName: 'incomeNature',
                        response: value.incomeNature,
                        relevanceResponseCRC: value.incomeNature1Relevance,
                        relevanceRemarksCRC: value.incomeNature1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[1].fields.push(client1Arr);
                }
                return true;
            });
        }

        if (values.client2 !== null && values.client2 !== undefined) {
            values.client2.map((value, index) => {
                //console.log('index.....', index);
                let client2Arr = {};
                if (value.country !== null) {
                    client2Arr = {
                        fieldName: 'country',
                        response: value.country,
                        relevanceResponseCRC: value.country1Relevance,
                        relevanceRemarksCRC: value.country1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[2].fields.push(client2Arr);
                }

                if (value.propAddress !== null) {
                    client2Arr = {
                        fieldName: 'propAddress',
                        response: value.propAddress,
                        relevanceResponseCRC: value.propAddressRelevance,
                        relevanceRemarksCRC: value.propAddressRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[2].fields.push(client2Arr);
                }

                if (value.ownership !== null) {
                    client2Arr = {
                        fieldName: 'ownership',
                        response: value.ownership,
                        relevanceResponseCRC: value.ownershipRelevance,
                        relevanceRemarksCRC: value.ownershipRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[2].fields.push(client2Arr);
                }
                if (value.acqisitionDate !== null) {
                    client2Arr = {
                        fieldName: 'acqisitionDate',
                        response: value.acqisitionDate,
                        relevanceResponseCRC: value.acqisitionDateRelevance,
                        relevanceRemarksCRC: value.acqisitionDateRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[2].fields.push(client2Arr);
                }
                if (value.totInvestment !== null) {
                    client2Arr = {
                        fieldName: 'totInvestment',
                        response: value.totInvestment,
                        relevanceResponseCRC: value.totInvestmentRelevance,
                        relevanceRemarksCRC: value.totInvestmentRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[2].fields.push(client2Arr);
                }
                if (value.propIncome !== null) {
                    client2Arr = {
                        fieldName: 'propIncome',
                        response: value.propIncome,
                        relevanceResponseCRC: value.propIncomeRelevance,
                        relevanceRemarksCRC: value.propIncomeRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[2].fields.push(client2Arr);
                }
                if (value.incomeNature !== null) {
                    client2Arr = {
                        fieldName: 'incomeNature',
                        response: value.incomeNature,
                        relevanceResponseCRC: value.incomeNatureRelevance,
                        relevanceRemarksCRC: value.incomeNatureRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[2].fields.push(client2Arr);
                }
                return true;
            });
        }

        if (values.client3 !== null && values.client3 !== undefined) {
            values.client3.map((value, index) => {
                //console.log('index.....', index);
                let client3Arr = {};
                if (value.country !== null) {
                    client3Arr = {
                        fieldName: 'country',
                        response: value.country,
                        relevanceResponseCRC: value.country1Relevance,
                        relevanceRemarksCRC: value.country1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[3].fields.push(client3Arr);
                }

                if (value.assetName !== null) {
                    client3Arr = {
                        fieldName: 'assetName',
                        response: value.assetName,
                        relevanceResponseCRC: value.assetNameRelevance,
                        relevanceRemarksCRC: value.assetNameRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[3].fields.push(client3Arr);
                }

                if (value.ownership !== null) {
                    client3Arr = {
                        fieldName: 'ownership',
                        response: value.ownership,
                        relevanceResponseCRC: value.ownershipRelevance,
                        relevanceRemarksCRC: value.ownershipRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[3].fields.push(client3Arr);
                }
                if (value.acqisitionDate !== null) {
                    client3Arr = {
                        fieldName: 'acqisitionDate',
                        response: value.acqisitionDate,
                        relevanceResponseCRC: value.acqisitionDateRelevance,
                        relevanceRemarksCRC: value.acqisitionDateRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[3].fields.push(client3Arr);
                }
                if (value.totInvestment !== null) {
                    client3Arr = {
                        fieldName: 'totInvestment',
                        response: value.totInvestment,
                        relevanceResponseCRC: value.totInvestmentRelevance,
                        relevanceRemarksCRC: value.totInvestmentRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[3].fields.push(client3Arr);
                }
                if (value.assetIncome !== null) {
                    client3Arr = {
                        fieldName: 'assetIncome',
                        response: value.assetIncome,
                        relevanceResponseCRC: value.assetIncomeRelevance,
                        relevanceRemarksCRC: value.assetIncomeRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[3].fields.push(client3Arr);
                }
                if (value.incomeNature !== null) {
                    client3Arr = {
                        fieldName: 'incomeNature',
                        response: value.incomeNature,
                        relevanceResponseCRC: value.incomeNatureRelevance,
                        relevanceRemarksCRC: value.incomeNatureRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[3].fields.push(client3Arr);
                }
                return true;
            });
        }

        if (values.client4 !== null && values.client4 !== undefined) {
            values.client4.map((value, index) => {
                //console.log('index.....', index);
                let client4Arr = {};
                if (value.institutionName !== null) {
                    client4Arr = {
                        fieldName: 'institutionName',
                        response: value.institutionName,
                        relevanceResponseCRC: value.institutionNameRelevance,
                        relevanceRemarksCRC: value.institutionNameRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[4].fields.push(client4Arr);
                }
                if (value.institutionAddr !== null) {
                    client4Arr = {
                        fieldName: 'institutionAddr',
                        response: value.institutionAddr,
                        relevanceResponseCRC: value.institutionAddrRelevance,
                        relevanceRemarksCRC: value.institutionAddrRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[4].fields.push(client4Arr);
                }
                if (value.accholderName !== null) {
                    client4Arr = {
                        fieldName: 'accholderName',
                        response: value.accholderName,
                        relevanceResponseCRC: value.accholderNameRelevance,
                        relevanceRemarksCRC: value.accholderNameRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[4].fields.push(client4Arr);
                }

                if (value.accountNumber !== null) {
                    client4Arr = {
                        fieldName: 'accountNumber',
                        response: value.accountNumber,
                        relevanceResponseCRC: value.accountNumberRelevance,
                        relevanceRemarksCRC: value.accountNumberRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[4].fields.push(client4Arr);
                }
                if (value.peakBal !== null) {
                    client4Arr = {
                        fieldName: 'peakBal',
                        response: value.peakBal,
                        relevanceResponseCRC: value.peakBalRelevance,
                        relevanceRemarksCRC: value.peakBalRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[4].fields.push(client4Arr);
                }
                return true;
            });
        }

        if (values.client5 !== null && values.client5 !== undefined) {
            values.client5.map((value, index) => {
                let client5Arr = {};
                if (value.country !== null) {
                    client5Arr = {
                        fieldName: 'country',
                        response: value.country,
                        relevanceResponseCRC: value.country1Relevance,
                        relevanceRemarksCRC: value.country1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[5].fields.push(client5Arr);
                }

                if (value.trustName !== null) {
                    client5Arr = {
                        fieldName: 'trustName',
                        response: value.trustName,
                        relevanceResponseCRC: value.trustNameRelevance,
                        relevanceRemarksCRC: value.trustNameRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[5].fields.push(client5Arr);
                }

                if (value.trustAddress !== null) {
                    client5Arr = {
                        fieldName: 'trustAddress',
                        response: value.trustAddress,
                        relevanceResponseCRC: value.trustAddressRelevance,
                        relevanceRemarksCRC: value.trustAddressRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[5].fields.push(client5Arr);
                }
                if (value.trusteeName !== null) {
                    client5Arr = {
                        fieldName: 'trusteeName',
                        response: value.trusteeName,
                        relevanceResponseCRC: value.trusteeNameRelevance,
                        relevanceRemarksCRC: value.trusteeNameRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[5].fields.push(client5Arr);
                }
                if (value.trusteeAddress !== null) {
                    client5Arr = {
                        fieldName: 'trusteeAddress',
                        response: value.trusteeAddress,
                        relevanceResponseCRC: value.trusteeAddressRelevance,
                        relevanceRemarksCRC: value.trusteeAddressRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[5].fields.push(client5Arr);
                }
                if (value.settlorAddress !== null) {
                    client5Arr = {
                        fieldName: 'settlorAddress',
                        response: value.settlorAddress,
                        relevanceResponseCRC: value.settlorAddressRelevance,
                        relevanceRemarksCRC: value.settlorAddressRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[5].fields.push(client5Arr);
                }
                if (value.settlorName !== null) {
                    client5Arr = {
                        fieldName: 'settlorName',
                        response: value.settlorName,
                        relevanceResponseCRC: value.settlorNameRelevance,
                        relevanceRemarksCRC: value.settlorNameRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[5].fields.push(client5Arr);
                }
                if (value.benfName !== null) {
                    client5Arr = {
                        fieldName: 'benfName',
                        response: value.benfName,
                        relevanceResponseCRC: value.benfNameRelevance,
                        relevanceRemarksCRC: value.benfNameRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[5].fields.push(client5Arr);
                }
                if (value.benfAddress !== null) {
                    client5Arr = {
                        fieldName: 'benfAddress',
                        response: value.benfAddress,
                        relevanceResponseCRC: value.benfAddressRelevance,
                        relevanceRemarksCRC: value.benfAddressRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[5].fields.push(client5Arr);
                }

                return true;
            });
        }

        if (values.client6 !== null && values.client6 !== undefined) {
            values.client6.map((value, index) => {
                let client6Arr = {};
                if (value.country !== null) {
                    client6Arr = {
                        fieldName: 'country',
                        response: value.country,
                        relevanceResponseCRC: value.country1Relevance,
                        relevanceRemarksCRC: value.country1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[6].fields.push(client6Arr);
                }

                if (value.personName !== null) {
                    client6Arr = {
                        fieldName: 'personName',
                        response: value.personName,
                        relevanceResponseCRC: value.personNameRelevance,
                        relevanceRemarksCRC: value.personNameRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[6].fields.push(client6Arr);
                }

                if (value.personAddr !== null) {
                    client6Arr = {
                        fieldName: 'personAddr',
                        response: value.personAddr,
                        relevanceResponseCRC: value.personAddrRelevance,
                        relevanceRemarksCRC: value.personAddrRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[6].fields.push(client6Arr);
                }
                if (value.derivedIncome !== null) {
                    client6Arr = {
                        fieldName: 'derivedIncome',
                        response: value.derivedIncome,
                        relevanceResponseCRC: value.derivedIncomeRelevance,
                        relevanceRemarksCRC: value.derivedIncomeRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[6].fields.push(client6Arr);
                }

                if (value.incomeNature !== null) {
                    client6Arr = {
                        fieldName: 'incomeNature',
                        response: value.incomeNature,
                        relevanceResponseCRC: value.incomeNatureRelevance,
                        relevanceRemarksCRC: value.incomeNatureRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[6].fields.push(client6Arr);
                }
                return true;
            });
        }

        if (values.client7 !== null && values.client7 !== undefined) {
            values.client7.map((value, index) => {
                let client7Arr = {};
                if (value.country !== null) {
                    client7Arr = {
                        fieldName: 'country',
                        response: value.country,
                        relevanceResponseCRC: value.country1Relevance,
                        relevanceRemarksCRC: value.country1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[7].fields.push(client7Arr);
                }

                if (value.institutionName !== null) {
                    client7Arr = {
                        fieldName: 'institutionName',
                        response: value.institutionName,
                        relevanceResponseCRC: value.institutionNameRelevance,
                        relevanceRemarksCRC: value.institutionNameRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[7].fields.push(client7Arr);
                }

                if (value.institutionAddr !== null) {
                    client7Arr = {
                        fieldName: 'institutionAddr',
                        response: value.institutionAddr,
                        relevanceResponseCRC: value.institutionAddrRelevance,
                        relevanceRemarksCRC: value.institutionAddrRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[7].fields.push(client7Arr);
                }
                if (value.zip !== null) {
                    client7Arr = {
                        fieldName: 'zip',
                        response: value.zip,
                        relevanceResponseCRC: value.zipRelevance,
                        relevanceRemarksCRC: value.zipRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[7].fields.push(client7Arr);
                }

                if (value.accountNumber !== null) {
                    client7Arr = {
                        fieldName: 'accountNumber',
                        response: value.accountNumber,
                        relevanceResponseCRC: value.accountNumberRelevance,
                        relevanceRemarksCRC: value.accountNumberRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[7].fields.push(client7Arr);
                }
                if (value.status !== null) {
                    client7Arr = {
                        fieldName: 'status',
                        response: value.status,
                        relevanceResponseCRC: value.statusRelevance,
                        relevanceRemarksCRC: value.statusRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[7].fields.push(client7Arr);
                }

                if (value.date !== null) {
                    client7Arr = {
                        fieldName: 'date',
                        response: value.date,
                        relevanceResponseCRC: value.dateRelevance,
                        relevanceRemarksCRC: value.dateRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[7].fields.push(client7Arr);
                }
                if (value.peakBalance !== null) {
                    client7Arr = {
                        fieldName: 'peakBalance',
                        response: value.peakBalance,
                        relevanceResponseCRC: value.peakBalanceRelevance,
                        relevanceRemarksCRC: value.peakBalanceRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[7].fields.push(client7Arr);
                }

                if (value.closingBalance !== null) {
                    client7Arr = {
                        fieldName: 'closingBalance',
                        response: value.closingBalance,
                        relevanceResponseCRC: value.closingBalanceRelevance,
                        relevanceRemarksCRC: value.closingBalanceRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[7].fields.push(client7Arr);
                }
                return true;
            });
        }

        if (values.client8 !== null && values.client8 !== undefined) {
            values.client8.map((value, index) => {
                let client8Arr = {};
                if (value.country !== null) {
                    client8Arr = {
                        fieldName: 'country',
                        response: value.country,
                        relevanceResponseCRC: value.country1Relevance,
                        relevanceRemarksCRC: value.country1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[8].fields.push(client8Arr);
                }

                if (value.institutionName !== null) {
                    client8Arr = {
                        fieldName: 'institutionName',
                        response: value.institutionName,
                        relevanceResponseCRC: value.institutionNameRelevance,
                        relevanceRemarksCRC: value.institutionNameRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[8].fields.push(client8Arr);
                }

                if (value.institutionAddr !== null) {
                    client8Arr = {
                        fieldName: 'institutionAddr',
                        response: value.institutionAddr,
                        relevanceResponseCRC: value.institutionAddrRelevance,
                        relevanceRemarksCRC: value.institutionAddrRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[8].fields.push(client8Arr);
                }
                if (value.zip !== null) {
                    client8Arr = {
                        fieldName: 'zip',
                        response: value.zip,
                        relevanceResponseCRC: value.zipRelevance,
                        relevanceRemarksCRC: value.zipRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[8].fields.push(client8Arr);
                }

                if (value.accountNumber !== null) {
                    client8Arr = {
                        fieldName: 'accountNumber',
                        response: value.accountNumber,
                        relevanceResponseCRC: value.accountNumberRelevance,
                        relevanceRemarksCRC: value.accountNumberRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[8].fields.push(client8Arr);
                }
                if (value.status !== null) {
                    client8Arr = {
                        fieldName: 'status',
                        response: value.status,
                        relevanceResponseCRC: value.statusRelevance,
                        relevanceRemarksCRC: value.statusRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[8].fields.push(client8Arr);
                }

                if (value.date !== null) {
                    client8Arr = {
                        fieldName: 'date',
                        response: value.date,
                        relevanceResponseCRC: value.dateRelevance,
                        relevanceRemarksCRC: value.dateRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[8].fields.push(client8Arr);
                }
                if (value.peakBalance !== null) {
                    client8Arr = {
                        fieldName: 'peakBalance',
                        response: value.peakBalance,
                        relevanceResponseCRC: value.peakBalanceRelevance,
                        relevanceRemarksCRC: value.peakBalanceRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[8].fields.push(client8Arr);
                }

                if (value.closingBalance !== null) {
                    client8Arr = {
                        fieldName: 'closingBalance',
                        response: value.closingBalance,
                        relevanceResponseCRC: value.closingBalanceRelevance,
                        relevanceRemarksCRC: value.closingBalanceRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[8].fields.push(client8Arr);
                }

                if (value.grossAmount !== null) {
                    client8Arr = {
                        fieldName: 'grossAmount',
                        response: value.grossAmount,
                        relevanceResponseCRC: value.grossAmountRelevance,
                        relevanceRemarksCRC: value.grossAmountRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[8].fields.push(client8Arr);
                }
                return true;
            });
        }

        if (values.client9 !== null && values.client9 !== undefined) {
            values.client9.map((value, index) => {
                let client9Arr = {};
                if (value.country !== null) {
                    client9Arr = {
                        fieldName: 'country',
                        response: value.country,
                        relevanceResponseCRC: value.country1Relevance,
                        relevanceRemarksCRC: value.country1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[9].fields.push(client9Arr);
                }

                if (value.entityName !== null) {
                    client9Arr = {
                        fieldName: 'entityName',
                        response: value.entityName,
                        relevanceResponseCRC: value.entityNameRelevance,
                        relevanceRemarksCRC: value.entityNameRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[9].fields.push(client9Arr);
                }

                if (value.entityAddress !== null) {
                    client9Arr = {
                        fieldName: 'entityAddress',
                        response: value.entityAddress,
                        relevanceResponseCRC: value.entityAddressRelevance,
                        relevanceRemarksCRC: value.entityAddressRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[9].fields.push(client9Arr);
                }
                if (value.zip !== null) {
                    client9Arr = {
                        fieldName: 'zip',
                        response: value.zip,
                        relevanceResponseCRC: value.zipRelevance,
                        relevanceRemarksCRC: value.zipRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[9].fields.push(client9Arr);
                }

                if (value.entityNature !== null) {
                    client9Arr = {
                        fieldName: 'entityNature',
                        response: value.entityNature,
                        relevanceResponseCRC: value.entityNatureRelevance,
                        relevanceRemarksCRC: value.entityNatureRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[9].fields.push(client9Arr);
                }
                if (value.acquireDate !== null) {
                    client9Arr = {
                        fieldName: 'acquireDate',
                        response: value.acquireDate,
                        relevanceResponseCRC: value.acquireDateRelevance,
                        relevanceRemarksCRC: value.acquireDateRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[9].fields.push(client9Arr);
                }

                if (value.initialInvest !== null) {
                    client9Arr = {
                        fieldName: 'initialInvest',
                        response: value.initialInvest,
                        relevanceResponseCRC: value.initialInvestRelevance,
                        relevanceRemarksCRC: value.initialInvestRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[9].fields.push(client9Arr);
                }
                if (value.peakInvest !== null) {
                    client9Arr = {
                        fieldName: 'peakInvest',
                        response: value.peakInvest,
                        relevanceResponseCRC: value.peakInvestRelevance,
                        relevanceRemarksCRC: value.peakInvestRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[9].fields.push(client9Arr);
                }

                if (value.closingBalance !== null) {
                    client9Arr = {
                        fieldName: 'closingBalance',
                        response: value.closingBalance,
                        relevanceResponseCRC: value.closingBalanceRelevance,
                        relevanceRemarksCRC: value.closingBalanceRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[9].fields.push(client9Arr);
                }

                if (value.grossAmount !== null) {
                    client9Arr = {
                        fieldName: 'grossAmount',
                        response: value.grossAmount,
                        relevanceResponseCRC: value.grossAmountRelevance,
                        relevanceRemarksCRC: value.grossAmountRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[9].fields.push(client9Arr);
                }
                return true;
            });
        }

        if (values.client10 !== null && values.client10 !== undefined) {
            values.client10.map((value, index) => {
                let client10Arr = {};
                if (value.country !== null) {
                    client10Arr = {
                        fieldName: 'country',
                        response: value.country,
                        relevanceResponseCRC: value.country1Relevance,
                        relevanceRemarksCRC: value.country1RelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[10].fields.push(client10Arr);
                }

                if (value.instiName !== null) {
                    client10Arr = {
                        fieldName: 'instiName',
                        response: value.instiName,
                        relevanceResponseCRC: value.instiNameRelevance,
                        relevanceRemarksCRC: value.instiNameRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[10].fields.push(client10Arr);
                }

                if (value.instiAddr !== null) {
                    client10Arr = {
                        fieldName: 'instiAddr',
                        response: value.instiAddr,
                        relevanceResponseCRC: value.instiAddrRelevance,
                        relevanceRemarksCRC: value.instiAddrRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[10].fields.push(client10Arr);
                }
                if (value.zip !== null) {
                    client10Arr = {
                        fieldName: 'zip',
                        response: value.zip,
                        relevanceResponseCRC: value.zipRelevance,
                        relevanceRemarksCRC: value.zipRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[10].fields.push(client10Arr);
                }
                if (value.date !== null) {
                    client10Arr = {
                        fieldName: 'date',
                        response: value.date,
                        relevanceResponseCRC: value.dateRelevance,
                        relevanceRemarksCRC: value.dateRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[10].fields.push(client10Arr);
                }
                if (value.cashValue !== null) {
                    client10Arr = {
                        fieldName: 'cashValue',
                        response: value.cashValue,
                        relevanceResponseCRC: value.cashValueRelevance,
                        relevanceRemarksCRC: value.cashValueRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[10].fields.push(client10Arr);
                }
                if (value.grossValue !== null) {
                    client10Arr = {
                        fieldName: 'grossValue',
                        response: value.grossValue,
                        relevanceResponseCRC: value.grossValueRelevance,
                        relevanceRemarksCRC: value.grossValueRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[6].subQuestion[10].fields.push(client10Arr);
                }
                return true;
            });
        }

        if (values.labelAdata !== null && values.labelAdata !== undefined) {
            values.labelAdata.map((value, index) => {
                let labelAdataArr = {};
                if (value.description !== null) {
                    labelAdataArr = {
                        fieldName: 'description',
                        response: value.description,
                        relevanceResponseCRC: value.descriptionRelevance,
                        relevanceRemarksCRC: value.descriptionRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[0].fields.push(labelAdataArr);
                }
                if (value.address !== null) {
                    labelAdataArr = {
                        fieldName: 'address',
                        response: value.address,
                        relevanceResponseCRC: value.addressRelevance,
                        relevanceRemarksCRC: value.addressRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[0].fields.push(labelAdataArr);
                }
                if (value.amount !== null) {
                    labelAdataArr = {
                        fieldName: 'amount',
                        response: value.amount,
                        relevanceResponseCRC: value.amountRelevance,
                        relevanceRemarksCRC: value.amountRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[0].fields.push(labelAdataArr);
                }
                return true;
            });
        }

        if (values.labelBdata !== null && values.labelBdata !== undefined) {
            values.labelBdata.map((value, index) => {
                let labelBdataArr = {};
                if (value.jewellaryBullions !== null) {
                    labelBdataArr = {
                        fieldName: 'jewellaryBullions',
                        response: value.jewellaryBullions,
                        relevanceResponseCRC: value.jewellaryBullionsRelevance,
                        relevanceRemarksCRC: value.jewellaryBullionsRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[1].fields.push(labelBdataArr);
                }
                if (value.archaeologicalCollections !== null) {
                    labelBdataArr = {
                        fieldName: 'archaeologicalCollections',
                        response: value.archaeologicalCollections,
                        relevanceResponseCRC: value.archaeologicalCollectionsRelevance,
                        relevanceRemarksCRC: value.archaeologicalCollectionsRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[1].fields.push(labelBdataArr);
                }
                if (value.vehiclesYatchBoatsAircrafts !== null) {
                    labelBdataArr = {
                        fieldName: 'vehiclesYatchBoatsAircrafts',
                        response: value.vehiclesYatchBoatsAircrafts,
                        relevanceResponseCRC: value.vehiclesYatchBoatsAircraftsRelevance,
                        relevanceRemarksCRC: value.vehiclesYatchBoatsAircraftsRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[1].fields.push(labelBdataArr);
                }
                if (value.faAAmount !== null) {
                    labelBdataArr = {
                        fieldName: 'faAAmount',
                        response: value.faAAmount,
                        relevanceResponseCRC: value.faAAmountRelevance,
                        relevanceRemarksCRC: value.faAAmountRelevanceRemarks,
                        relevanceResponseAM: 'Relevant',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[1].fields.push(labelBdataArr);
                }
                if (value.faBAmount !== null) {
                    labelBdataArr = {
                        fieldName: 'faBAmount',
                        response: value.faBAmount,
                        relevanceResponseCRC: value.faBAmountRelevance,
                        relevanceRemarksCRC: value.faBAmountRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[1].fields.push(labelBdataArr);
                }
                if (value.faCAmount !== null) {
                    labelBdataArr = {
                        fieldName: 'faCAmount',
                        response: value.faCAmount,
                        relevanceResponseCRC: value.faCAmountRelevance,
                        relevanceRemarksCRC: value.faCAmountRelevance,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[1].fields.push(labelBdataArr);
                }
                if (value.faDAmount !== null) {
                    labelBdataArr = {
                        fieldName: 'faDAmount',
                        response: value.faDAmount,
                        relevanceResponseCRC: value.faDAmountRelevance,
                        relevanceRemarksCRC: value.faDAmountRelevance,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[1].fields.push(labelBdataArr);
                }
                if (value.faEAmount !== null) {
                    labelBdataArr = {
                        fieldName: 'faEAmount',
                        response: value.faEAmount,
                        relevanceResponseCRC: value.faEAmountRelevance,
                        relevanceRemarksCRC: value.faEAmountRelevance,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[1].fields.push(labelBdataArr);
                }
                return true;
            });
        }

        if (values.labelCdata !== null && values.labelCdata !== undefined) {
            values.labelCdata.map((value, index) => {
                let labelCdataArr = {};
                if (value.name !== null) {
                    labelCdataArr = {
                        fieldName: 'name',
                        response: value.name,
                        relevanceResponseCRC: value.nameCRelevance,
                        relevanceRemarksCRC: value.nameCRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[2].fields.push(labelCdataArr);
                }
                if (value.pan !== null) {
                    labelCdataArr = {
                        fieldName: 'pan',
                        response: value.pan,
                        relevanceResponseCRC: value.panCRelevance,
                        relevanceRemarksCRC: value.panCRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[2].fields.push(labelCdataArr);
                }
                if (value.particularShare !== null) {
                    labelCdataArr = {
                        fieldName: 'particularShare',
                        response: value.particularShare,
                        relevanceResponseCRC: value.particularShareCRelevance,
                        relevanceRemarksCRC: value.particularShareCRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[2].fields.push(labelCdataArr);
                }
                if (value.particularCost !== null) {
                    labelCdataArr = {
                        fieldName: 'particularCost',
                        response: value.particularCost,
                        relevanceResponseCRC: value.particularCostCRelevance,
                        relevanceRemarksCRC: value.particularCostCRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[2].fields.push(labelCdataArr);
                }
                if (value.acquiredShare !== null) {
                    labelCdataArr = {
                        fieldName: 'acquiredShare',
                        response: value.acquiredShare,
                        relevanceResponseCRC: value.acquiredShareCRelevance,
                        relevanceRemarksCRC: value.acquiredShareCRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[2].fields.push(labelCdataArr);
                }
                if (value.acquiredDate !== null) {
                    labelCdataArr = {
                        fieldName: 'acquiredDate',
                        response: value.acquiredDate,
                        relevanceResponseCRC: value.acquiredDateCRelevance,
                        relevanceRemarksCRC: value.acquiredDateCRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[2].fields.push(labelCdataArr);
                }
                if (value.acquiredValue !== null) {
                    labelCdataArr = {
                        fieldName: 'acquiredValue',
                        response: value.acquiredValue,
                        relevanceResponseCRC: value.acquiredValueCRelevance,
                        relevanceRemarksCRC: value.acquiredValueCRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[2].fields.push(labelCdataArr);
                }
                if (value.acquiredIssuePrice !== null) {
                    labelCdataArr = {
                        fieldName: 'acquiredIssuePrice',
                        response: value.acquiredIssuePrice,
                        relevanceResponseCRC: value.acquiredIPCRelevance,
                        relevanceRemarksCRC: value.acquiredIPCRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[2].fields.push(labelCdataArr);
                }
                if (value.acquiredPurchasePrice !== null) {
                    labelCdataArr = {
                        fieldName: 'acquiredPurchasePrice',
                        response: value.acquiredPurchasePrice,
                        relevanceResponseCRC: value.acquiredPPCRelevance,
                        relevanceRemarksCRC: value.acquiredPPCRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[2].fields.push(labelCdataArr);
                }
                if (value.transferredShare !== null) {
                    labelCdataArr = {
                        fieldName: 'transferredShare',
                        response: value.transferredShare,
                        relevanceResponseCRC: value.tsCRelevance,
                        relevanceRemarksCRC: value.tsCRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[2].fields.push(labelCdataArr);
                }
                if (value.transferredSale !== null) {
                    labelCdataArr = {
                        fieldName: 'transferredSale',
                        response: value.transferredSale,
                        relevanceResponseCRC: value.tsaleCRelevance,
                        relevanceRemarksCRC: value.tsaleCRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[2].fields.push(labelCdataArr);
                }
                if (value.closingShare !== null) {
                    labelCdataArr = {
                        fieldName: 'closingShare',
                        response: value.closingShare,
                        relevanceResponseCRC: value.closingShareCRelevance,
                        relevanceRemarksCRC: value.closingSharetsaleCRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[2].fields.push(labelCdataArr);
                }
                if (value.closingCost !== null) {
                    labelCdataArr = {
                        fieldName: 'closingCost',
                        response: value.closingCost,
                        relevanceResponseCRC: value.closingCostCRelevance,
                        relevanceRemarksCRC: value.closingCostsaleCRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[2].fields.push(labelCdataArr);
                }
                if (value.closingSale !== null) {
                    labelCdataArr = {
                        fieldName: 'closingSale',
                        response: value.closingSale,
                        relevanceResponseCRC: value.closingSaleCRelevance,
                        relevanceRemarksCRC: value.closingSaleCRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[2].fields.push(labelCdataArr);
                }
                if (value.noOfShare !== null) {
                    labelCdataArr = {
                        fieldName: 'noOfShare',
                        response: value.noOfShare,
                        relevanceResponseCRC: value.noOfShareCRelevance,
                        relevanceRemarksCRC: value.noOfShareCRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[2].fields.push(labelCdataArr);
                }
                if (value.costOfAcquisition !== null) {
                    labelCdataArr = {
                        fieldName: 'costOfAcquisition',
                        response: value.costOfAcquisition,
                        relevanceResponseCRC: value.costOfAcquisitionCRelevance,
                        relevanceRemarksCRC: value.costOfAcquisitionCRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[2].fields.push(labelCdataArr);
                }
                return true;
            });
        }

        if (values.labelDdata !== null && values.labelDdata !== undefined) {
            values.labelDdata.map((value, index) => {
                let labelDdataArr = {};
                if (value.name !== null) {
                    labelDdataArr = {
                        fieldName: 'name',
                        response: value.name,
                        relevanceResponseCRC: value.nameDRelevance,
                        relevanceRemarksCRC: value.nameDRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[3].fields.push(labelDdataArr);
                }
                if (value.pan !== null) {
                    labelDdataArr = {
                        fieldName: 'pan',
                        response: value.pan,
                        relevanceResponseCRC: value.panDRelevance,
                        relevanceRemarksCRC: value.panDRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[3].fields.push(labelDdataArr);
                }
                if (value.value !== null) {
                    labelDdataArr = {
                        fieldName: 'value',
                        response: value.value,
                        relevanceResponseCRC: value.valueDRelevance,
                        relevanceRemarksCRC: value.valueDRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[3].fields.push(labelDdataArr);
                }
                return true;
            });
        }

        if (values.labelEdata !== null && values.labelEdata !== undefined) {
            values.labelEdata.map((value, index) => {
                let labelEdataArr = {};
                if (value.particular !== null) {
                    labelEdataArr = {
                        fieldName: 'particular',
                        response: value.particular,
                        relevanceResponseCRC: value.particularRelevance,
                        relevanceRemarksCRC: value.particularRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[4].fields.push(labelEdataArr);
                }
                if (value.amount !== null) {
                    labelEdataArr = {
                        fieldName: 'amount',
                        response: value.amount,
                        relevanceResponseCRC: value.amountERelevance,
                        relevanceRemarksCRC: value.amountERelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[7].subQuestion[4].fields.push(labelEdataArr);
                }
                return true;
            });
        }
        if (values.capitalgain !== null && values.capitalgain !== undefined) {
            values.capitalgain.map((value, index) => {
                let capitalgainArr = {};
                if (value.natureAssets !== null) {
                    capitalgainArr = {
                        fieldName: 'natureAssets',
                        response: value.natureAssets,
                        relevanceResponseCRC: value.balanceCRCrelevenceResponse,
                        relevanceRemarksCRC: value.balanceCRCrelevenceRemarks,
                        relevanceResponseAM: 'Relevant',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[3].fields.push(capitalgainArr);
                }
                if (value.natureAssetsUpload !== null) {
                    capitalgainArr = {
                        fieldName: 'natureAssetsUpload',
                        response: value.natureAssetsUpload,
                        relevanceResponseCRC: '',
                        relevanceRemarksCRC: '',
                        relevanceResponseAM: 'Relevant',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[3].fields.push(capitalgainArr);
                }
                return true;
            });
        }

        if (values.agriculture !== null && values.agriculture !== undefined) {
            values.agriculture.map((value, index) => {
                let agricultureArr = {};
                if (value.agricultureName !== null) {
                    agricultureArr = {
                        fieldName: 'agricultureName',
                        response: value.agricultureName,
                        relevanceResponseCRC: value.agricultureNameCRCrelevenceResponse,
                        relevanceRemarksCRC: value.agricultureNameCRCrelevenceRemarks,
                        relevanceResponseAM: 'Relevant',
                        relevanceRemarksAM: '',
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[5].fields.push(agricultureArr);
                }
                if (value.agriAmount !== null) {
                    agricultureArr = {
                        fieldName: 'agriAmount',
                        response: value.agriAmount,
                        relevanceResponseCRC: value.agriAmountCRCrelevenceResponse,
                        relevanceRemarksCRC: value.agriAmountCRCrelevenceRemarks,
                        relevanceResponseAM: 'Relevant',
                        relevanceRemarksAM: '',
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[5].fields.push(agricultureArr);
                }
                if (value.agriReceipt !== null) {
                    agricultureArr = {
                        fieldName: 'agriReceipt',
                        response: value.agriReceipt,
                        relevanceResponseCRC: value.agriReceiptCRCrelevenceResponse,
                        relevanceRemarksCRC: value.agriReceiptCRCrelevenceRemarks,
                        relevanceResponseAM: 'Relevant',
                        relevanceRemarksAM: '',
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[5].fields.push(agricultureArr);
                }
                if (value.agriExpenses !== null) {
                    agricultureArr = {
                        fieldName: 'agriExpenses',
                        response: value.agriExpenses,
                        relevanceResponseCRC: value.agriExpensesCRCrelevenceResponse,
                        relevanceRemarksCRC: value.agriExpensesCRCrelevenceRemarks,
                        relevanceResponseAM: 'Relevant',
                        relevanceRemarksAM: '',
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[5].fields.push(agricultureArr);
                }
                if (value.agriReceiptUpload !== null) {
                    agricultureArr = {
                        fieldName: 'agriReceiptUpload',
                        response: value.agriReceiptUpload,
                        relevanceResponseCRC: value.agriReceiptUploadCRCrelevenceResponse,
                        relevanceRemarksCRC: value.agriReceiptUploadCRCrelevenceRemarks,
                        relevanceResponseAM: 'Relevant',
                        relevanceRemarksAM: '',
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[5].fields.push(agricultureArr);
                }
                if (value.agricultureName !== null) {
                    agricultureArr = {
                        fieldName: 'agriExpensesUpload',
                        response: value.agriExpensesUpload,
                        relevanceResponseCRC: value.agriExpensesUploadCRCrelevenceResponse,
                        relevanceRemarksCRC: value.agriExpensesUploadCRCrelevenceRemarks,
                        relevanceResponseAM: 'Relevant',
                        relevanceRemarksAM: '',
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[5].fields.push(agricultureArr);
                }
                return true;
            });
        }

        if (values.divident !== null && values.divident !== undefined) {
            values.divident.map((value, index) => {
                let dividentArr = {};
                if (value.divPayer !== null) {
                    dividentArr = {
                        fieldName: 'divPayer',
                        response: value.divPayer,
                        relevanceResponseCRC: value.divPayerCRCrelevenceResponse,
                        relevanceRemarksCRC: value.divPayerCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[0].fields.push(dividentArr);
                }
                if (value.divAmount !== null) {
                    dividentArr = {
                        fieldName: 'divAmount',
                        response: value.divAmount,
                        relevanceResponseCRC: value.divAmountCRCrelevenceResponse,
                        relevanceRemarksCRC: value.divAmountCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[0].fields.push(dividentArr);
                }
                if (value.divUpload !== null) {
                    dividentArr = {
                        fieldName: 'divUpload',
                        response: value.divUpload,
                        relevanceResponseCRC: '',
                        relevanceRemarksCRC: '',
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[0].fields.push(dividentArr);
                }
                return true;
            });
        }
        if (values.fd !== null && values.fd !== undefined) {
            values.fd.map((value, index) => {
                let fdArr = {};
                if (value.fdPayer !== null) {
                    fdArr = {
                        fieldName: 'fdPayer',
                        response: value.fdPayer,
                        relevanceResponseCRC: value.fdPayerCRCrelevenceResponse,
                        relevanceRemarksCRC: value.fdPayerCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[1].fields.push(fdArr);
                }
                if (value.fdAmount !== null) {
                    fdArr = {
                        fieldName: 'fdAmount',
                        response: value.fdAmount,
                        relevanceResponseCRC: value.fdAmountCRCrelevenceResponse,
                        relevanceRemarksCRC: value.fdAmountCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[1].fields.push(fdArr);
                }
                if (value.fdUpload !== null) {
                    fdArr = {
                        fieldName: 'fdUpload',
                        response: value.fdUpload,
                        relevanceResponseCRC: '',
                        relevanceRemarksCRC: '',
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[1].fields.push(fdArr);
                }
                return true;
            });
        }

        if (values.othersources !== null && values.othersources !== undefined) {
            values.othersources.map((value, index) => {
                let otherArr = {};
                if (value.otherPayer !== null) {
                    otherArr = {
                        fieldName: 'otherPayer',
                        response: value.otherPayer,
                        relevanceResponseCRC: value.otherPayerCRCrelevenceResponse,
                        relevanceRemarksCRC: value.otherPayerCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[2].fields.push(otherArr);
                }
                if (value.otherAmount !== null) {
                    otherArr = {
                        fieldName: 'otherAmount',
                        response: value.otherAmount,
                        relevanceResponseCRC: value.otherAmountCRCrelevenceResponse,
                        relevanceRemarksCRC: value.otherAmountCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[2].fields.push(otherArr);
                }
                if (value.otherUpload !== null) {
                    otherArr = {
                        fieldName: 'otherUpload',
                        response: value.otherUpload,
                        relevanceResponseCRC: '',
                        relevanceRemarksCRC: '',
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[2].fields.push(otherArr);
                }
                return true;
            });
        }

        if (values.bankDetails !== null && values.bankDetails !== undefined) {
            values.bankDetails.map((value, index) => {
                let bankDetailsArr = {};
                if (value.bankName !== null) {
                    bankDetailsArr = {
                        fieldName: 'bankName',
                        response: value.bankName,
                        relevanceResponseCRC: value.bankNameRelevance,
                        relevanceRemarksCRC: value.bankNameRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[1].fields.push(bankDetailsArr);
                }
                if (value.accountNumber !== null) {
                    bankDetailsArr = {
                        fieldName: 'accountNumber',
                        response: value.accountNumber,
                        relevanceResponseCRC: value.accountNoRelevance,
                        relevanceRemarksCRC: value.accountNoRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[1].fields.push(bankDetailsArr);
                }
                if (value.ifscCode !== null) {
                    bankDetailsArr = {
                        fieldName: 'ifscCode',
                        response: value.ifscCode,
                        relevanceResponseCRC: value.ifscCodeRelevance,
                        relevanceRemarksCRC: value.ifscCodeRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[1].fields.push(bankDetailsArr);
                }
                if (value.typeOfAcc !== null) {
                    bankDetailsArr = {
                        fieldName: 'typeOfAcc',
                        response: value.typeOfAcc,
                        relevanceResponseCRC: value.accTypeRelevance,
                        relevanceRemarksCRC: value.accTypeRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[1].fields.push(bankDetailsArr);
                }
                if (value.interestOfSavingsBank !== null) {
                    bankDetailsArr = {
                        fieldName: 'interestOfSavingsBank',
                        response: value.interestOfSavingsBank,
                        relevanceResponseCRC: value.jointAccNameRelevance,
                        relevanceRemarksCRC: value.jointAccNameRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[1].fields.push(bankDetailsArr);
                }
                if (value.checkedBank !== null) {
                    bankDetailsArr = {
                        fieldName: 'checkedBank',
                        response: value.checkedBank,
                        relevanceResponseCRC: value.checkedBankRelevance,
                        relevanceRemarksCRC: value.checkedBankRelevanceRemarks,
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[1].fields.push(bankDetailsArr);
                }
                if (value.bankStatementUpload !== null) {
                    bankDetailsArr = {
                        fieldName: 'bankStatementUpload',
                        response: value.bankStatementUpload,
                        relevanceResponseCRC: '',
                        relevanceRemarksCRC: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[1].fields.push(bankDetailsArr);
                }
                return true;
            });
        }

        if (values.investment !== null && values.investment !== undefined) {
            values.investment.map((value, index) => {
                let investmentArr = {};
                if (value.investmentDetails !== null) {
                    investmentArr = {
                        fieldName: 'investmentDetails',
                        response: value.investmentDetails,
                        relevanceResponseCRC: value.investmentDetailsCRCRelevenceResponse,
                        relevanceRemarksCRC: value.investmentDetailsCRCRelevenceRemarks,
                        relevanceResponseAM: 'Relevant',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[1].fields.push(investmentArr);
                }
                if (value.investmentAmt !== null) {
                    investmentArr = {
                        fieldName: 'investmentAmt',
                        response: value.investmentAmt,
                        relevanceResponseCRC: value.investmentAmtCRCRelevenceResponse,
                        relevanceRemarksCRC: value.investmentAmtCRCRelevenceRemarks,
                        relevanceResponseAM: 'Relevant',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[1].fields.push(investmentArr);
                }
                if (value.invAmtUpload !== null) {
                    investmentArr = {
                        fieldName: 'invAmtUpload',
                        response: value.invAmtUpload,
                        relevanceResponseCRC: value.invAmtUploadCRCRelevenceResponse,
                        relevanceRemarksCRC: value.invAmtUploadCRCRelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[1].fields.push(investmentArr);
                }
                return true;
            });
        }

        if (values.donation !== null && values.donation !== undefined) {
            values.donation.map((value, index) => {
                let donationArr = {};
                if (value.donationDetails !== null) {
                    donationArr = {
                        fieldName: 'donationDetails',
                        response: value.donationDetails,
                        relevanceResponseCRC: value.donationDetailsCRCRelevenceResponse,
                        relevanceRemarksCRC: value.donationDetailsCRCRelevenceRemarks,
                        relevanceResponseAM: 'Relevant',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[2].fields.push(donationArr);
                }

                if (value.donationAmt !== null) {
                    donationArr = {
                        fieldName: 'donationAmt',
                        response: value.donationAmt,
                        relevanceResponseCRC: value.donationAmountCRCRelevenceResponse,
                        relevanceRemarksCRC: value.donationAmountCRCRelevenceRemarks,
                        relevanceResponseAM: 'Relevant',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[2].fields.push(donationArr);
                }
                if (value.donationAmtUpload !== null) {
                    donationArr = {
                        fieldName: 'donationAmtUpload',
                        response: value.donationAmtUpload,
                        relevanceResponseCRC: value.donationAmtUploadCRCRelevenceResponse,
                        relevanceRemarksCRC: value.donationAmtUploadCRCRelevenceRemarks,
                        relevanceResponseAM: 'Relevant',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[2].fields.push(donationArr);
                }
                return true;
            });
        }

        if (values.houseproperty !== null && values.houseproperty !== undefined) {
            values.houseproperty.map((value, index) => {
                let housePropertyIndex = index;
                let houseAddressArr = {};
                if (value.houseAddress !== null) {
                    houseAddressArr = {
                        fieldName: 'houseAddress',
                        response: value.houseAddress,
                        relevanceResponseCRC: value.houseAddressCRCrelevenceResponse,
                        relevanceRemarksCRC: value.houseAddressCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[1].fields.push(houseAddressArr);
                }

                if (value.houseStatusType !== null) {
                    houseAddressArr = {
                        fieldName: 'houseStatusType',
                        response: value.houseStatusType,
                        relevanceResponseCRC: value.houseStatusTypeCRCrelevenceResponse,
                        relevanceRemarksCRC: value.houseStatusTypeCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[1].fields.push(houseAddressArr);
                }

                if (value.rent !== null) {
                    houseAddressArr = {
                        fieldName: 'rentreceived',
                        response: value.rent,
                        relevanceResponseCRC: value.rentCRCrelevenceResponse,
                        relevanceRemarksCRC: value.rentCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[1].fields.push(houseAddressArr);
                }

                if (value.propTax !== null) {
                    houseAddressArr = {
                        fieldName: 'Propertytaxpaid',
                        response: value.propTax,
                        relevanceResponseCRC: value.propTaxCRCrelevenceResponse,
                        relevanceRemarksCRC: value.propTaxCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[1].fields.push(houseAddressArr);
                }
                if (value.tenantName !== null) {
                    houseAddressArr = {
                        fieldName: 'tenantName',
                        response: value.tenantName,
                        relevanceResponseCRC: value.tenantNameCRCrelevenceResponse,
                        relevanceRemarksCRC: value.tenantNameCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[1].fields.push(houseAddressArr);
                }
                if (value.pan !== null) {
                    houseAddressArr = {
                        fieldName: 'pan',
                        response: value.pan,
                        relevanceResponseCRC: value.panCRCrelevenceResponse,
                        relevanceRemarksCRC: value.panCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[1].fields.push(houseAddressArr);
                }
                if (value.housepurposeType !== null) {
                    houseAddressArr = {
                        fieldName: 'housepurposeType',
                        response: value.housepurposeType,
                        relevanceResponseCRC: value.housepurposeTypeCRCrelevenceResponse,
                        relevanceRemarksCRC: value.housepurposeTypeCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[1].fields.push(houseAddressArr);
                }
                if (value.upload !== null) {
                    houseAddressArr = {
                        fieldName: 'rentUpload',
                        response: value.rentUpload,
                        relevanceResponseCRC: '',
                        relevanceRemarksCRC: '',
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[1].fields.push(houseAddressArr);
                }
                if (value.TDSdeductedinrentType !== null) {
                    houseAddressArr = {
                        fieldName: 'TDSdeductedinrentType',
                        response: value.TDSdeductedinrentType,
                        relevanceResponseCRC: value.TDSdeductedinrentTypeCRCrelevenceResponse,
                        relevanceRemarksCRC: value.TDSdeductedinrentTypeCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[1].fields.push(houseAddressArr);
                }
                if (value.upload !== null) {
                    houseAddressArr = {
                        fieldName: 'propertyUpload',
                        response: value.propertyUpload,
                        relevanceResponseCRC: '',
                        relevanceRemarksCRC: '',
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[1].fields.push(houseAddressArr);
                }
                if (value.haveyoutakenanyhousingloanType !== null) {
                    houseAddressArr = {
                        fieldName: 'haveyoutakenanyhousingloanType',
                        response: value.haveyoutakenanyhousingloanType,
                        relevanceResponseCRC: value.haveyoutakenanyhousingloanTypeCRCrelevenceResponse,
                        relevanceRemarksCRC: value.haveyoutakenanyhousingloanTypeCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[1].fields.push(houseAddressArr);
                }
                if (value.propertyCoOwnedType !== null) {
                    houseAddressArr = {
                        fieldName: 'propertyCoOwnedType',
                        response: value.propertyCoOwnedType,
                        relevanceResponseCRC: '',
                        relevanceRemarksCRC: '',
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[1].fields.push(houseAddressArr);
                }
                if (value.coowner !== null || value.coowner.length > 0 || value.coowner !== undefined) {
                    let coOwnerArrayFields = [];
                    value.coowner.map((coOwnerValue, index) => {
                        if (coOwnerValue.coownerName !== null) {
                            let coOwnerArray = {
                                sectionText: 'coownerName-' + housePropertyIndex,
                                response: coOwnerValue.coownerName,
                                relevanceResponseCRC: coOwnerValue.coownerNameCRCrelevenceResponse,
                                relevanceRemarksCRC: coOwnerValue.coownerNameCRCrelevenceRemarks,
                                relevanceResponseAM: '',
                                relevanceRemarksAM: '',
                                autoPopulate: true,
                                coownerID: housePropertyIndex,
                            };
                            data.checklistJson.checklistL1.questions[2].subQuestion[1].subSubQuestions.push(coOwnerArray);
                        }
                        if (coOwnerValue.coownerPan !== null) {
                            let coOwnerArray = {
                                sectionText: 'coownerPan-' + housePropertyIndex,
                                response: coOwnerValue.coownerPan,
                                relevanceResponseCRC: coOwnerValue.coownerPanCRCrelevenceResponse,
                                relevanceRemarksCRC: coOwnerValue.coownerPanCRCrelevenceRemarks,
                                relevanceResponseAM: '',
                                relevanceRemarksAM: '',
                                autoPopulate: true,
                                coownerID: housePropertyIndex,
                            };
                            data.checklistJson.checklistL1.questions[2].subQuestion[1].subSubQuestions.push(coOwnerArray);
                        }
                        if (coOwnerValue.share !== null) {
                            let coOwnerArray = {
                                sectionText: 'share-' + housePropertyIndex,
                                response: coOwnerValue.share,
                                relevanceResponseCRC: coOwnerValue.shareCRCrelevenceResponse,
                                relevanceRemarksCRC: coOwnerValue.shareCRCrelevenceRemarks,
                                relevanceResponseAM: '',
                                relevanceRemarksAM: '',
                                autoPopulate: true,
                                coownerID: housePropertyIndex,
                            };
                            data.checklistJson.checklistL1.questions[2].subQuestion[1].subSubQuestions.push(coOwnerArray);
                        }
                    });
                }
                if (value.upload !== null) {
                    houseAddressArr = {
                        fieldName: 'loanUpload',
                        response: value.loanUpload,
                        relevanceResponseCRC: value.loanUploadCRCrelevenceResponse,
                        relevanceRemarksCRC: value.loanUploadCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[1].fields.push(houseAddressArr);
                }
                if (value.upload !== null) {
                    houseAddressArr = {
                        fieldName: 'TDSUpload',
                        response: value.TDSUpload,
                        relevanceResponseCRC: value.TDSUploadCRCrelevenceResponse,
                        relevanceRemarksCRC: value.TDSUploadCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[1].fields.push(houseAddressArr);
                }
                return true;
            });
        }

        if (values.tallyYes !== null && values.tallyYes !== undefined) {
            values.tallyYes.map((value, index) => {
                let tallyYesArr = {};
                if (value.nameFirm !== null) {
                    tallyYesArr = {
                        fieldName: 'nameFirm',
                        response: value.nameFirm,
                        relevanceResponseCRC: value.nameFirmCRCrelevenceResponse,
                        relevanceRemarksCRC: value.nameFirmCRCrelevenceRemarks,
                        relevanceResponseAM: 'Relevant',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields.push(tallyYesArr);
                }

                if (value.panNoFirm !== null) {
                    tallyYesArr = {
                        fieldName: 'panNoFirm',
                        response: value.panNoFirm,
                        relevanceResponseCRC: value.panNoFirmCRCrelevenceResponse,
                        relevanceRemarksCRC: value.panNoFirmCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields.push(tallyYesArr);
                }

                if (value.remunRec !== null) {
                    tallyYesArr = {
                        fieldName: 'remunRec',
                        response: value.remunRec,
                        relevanceResponseCRC: value.remunRecCRCrelevenceResponse,
                        relevanceRemarksCRC: value.remunRecCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields.push(tallyYesArr);
                }
                if (value.amtInt !== null) {
                    tallyYesArr = {
                        fieldName: 'amtInt',
                        response: value.amtInt,
                        relevanceResponseCRC: value.amtIntCRCrelevenceResponse,
                        relevanceRemarksCRC: value.amtIntCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields.push(tallyYesArr);
                }
                if (value.shareProfit !== null) {
                    tallyYesArr = {
                        fieldName: 'shareProfit',
                        response: value.shareProfit,
                        relevanceResponseCRC: value.shareProfitCRCrelevenceResponse,
                        relevanceRemarksCRC: value.shareProfitCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields.push(tallyYesArr);
                }
                if (value.shareProfitRs !== null) {
                    tallyYesArr = {
                        fieldName: 'shareProfitRs',
                        response: value.shareProfitRs,
                        relevanceResponseCRC: value.shareProfitRsCRCrelevenceResponse,
                        relevanceRemarksCRC: value.shareProfitRsCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields.push(tallyYesArr);
                }
                if (value.firmAudit !== null) {
                    tallyYesArr = {
                        fieldName: 'firmAudit',
                        response: value.firmAudit,
                        relevanceResponseCRC: value.firmAuditCRCrelevenceResponse,
                        relevanceRemarksCRC: value.firmAuditCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields.push(tallyYesArr);
                }
                if (value.transferPrice !== null) {
                    tallyYesArr = {
                        fieldName: 'transferPrice',
                        response: value.transferPrice,
                        relevanceResponseCRC: value.transferPriceCRCrelevenceResponse,
                        relevanceRemarksCRC: value.transferPriceCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields.push(tallyYesArr);
                }
                if (value.balance !== null) {
                    tallyYesArr = {
                        fieldName: 'balance',
                        response: value.balance,
                        relevanceResponseCRC: value.balanceCRCrelevenceResponse,
                        relevanceRemarksCRC: value.balanceCRCrelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields.push(tallyYesArr);
                }
                return true;
            });
        }

        if (values.investment1 !== null && values.investment1 !== undefined) {
            values.investment1.map((value, index) => {
                // console.log('investment1..value', value);
                let investmentArr = {};
                if (value.investmentDetails !== null) {
                    investmentArr = {
                        fieldName: 'investmentDetails',
                        response: value.investmentDetails,
                        relevanceResponseCRC: value.investmentDetailsCRCRelevenceResponse,
                        relevanceRemarksCRC: value.investmentDetailsCRCRelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[6].subSubQuestions[0].fields.push(investmentArr);
                }
                if (value.investmentAmt !== null) {
                    investmentArr = {
                        fieldName: 'investmentAmt',
                        response: value.investmentAmt,
                        relevanceResponseCRC: value.investmentAmtCRCRelevenceResponse,
                        relevanceRemarksCRC: value.investmentAmtCRCRelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[6].subSubQuestions[0].fields.push(investmentArr);
                }
                if (value.invAmtUpload !== null) {
                    investmentArr = {
                        fieldName: 'invAmtUpload',
                        response: value.invAmtUpload,
                        relevanceResponseCRC: value.invAmtUploadCRCRelevenceResponse,
                        relevanceRemarksCRC: value.invAmtUploadCRCRelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[6].subSubQuestions[0].fields.push(investmentArr);
                }
                return true;
            });
        }

        if (values.donation1 !== null && values.donation1 !== undefined) {
            values.donation1.map((value, index) => {
                let donationArr = {};
                if (value.donationDetails !== null) {
                    donationArr = {
                        fieldName: 'donationDetails',
                        response: value.donationDetails,
                        relevanceResponseCRC: value.donationDetailsCRCRelevenceResponse,
                        relevanceRemarksCRC: value.donationDetailsCRCRelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[6].subSubQuestions[1].fields.push(donationArr);
                }

                if (value.donationAmt !== null) {
                    donationArr = {
                        fieldName: 'donationAmt',
                        response: value.donationAmt,
                        relevanceResponseCRC: value.donationAmountCRCRelevenceResponse,
                        relevanceRemarksCRC: value.donationAmountCRCRelevenceRemarks,
                        relevanceResponseAM: '',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[6].subSubQuestions[1].fields.push(donationArr);
                }
                if (value.donationAmtUpload !== null) {
                    donationArr = {
                        fieldName: 'donationAmtUpload',
                        response: value.donationAmtUpload,
                        relevanceResponseCRC: value.donationAmtUploadCRCRelevenceResponse,
                        relevanceRemarksCRC: value.donationAmtUploadCRCRelevenceRemarks,
                        relevanceResponseAM: 'Relevant',
                        relevanceRemarksAM: '',
                        autoPopulate: true,
                        coownerID: index + 1,
                    };
                    data.checklistJson.checklistL1.questions[2].subQuestion[6].subSubQuestions[1].fields.push(donationArr);
                }
                return true;
            });
        }
        console.log('SUBMIT =>>>>> DATA', data);

        if (userType === 'Ultimate Client') {
            const res = yield call(axios, `/api/itr/checklist/submit-response/${tennantnameValue}`, {
                method: 'put',
                baseURL: `${CommonConfig.dev.baseUrl1}`,
                data: data,
                headers: {
                    Authorization: bearerToken,
                },
            });
            const creategeninfosumbit = res.data;
            yield put({ type: CreateGenInfoRequestSubmitActionTypes.SUCCESS, payload: creategeninfosumbit });
        } else if (userType === 'ITeC AM and above') {
            const resAM = yield call(axios, `/api/itr/checklist/am-approve-relevance/${imcNameSelected}`, {
                method: 'put',
                baseURL: `${CommonConfig.dev.baseUrl1}`,
                data: data,
                headers: {
                    Authorization: bearerToken,
                },
            });
            const creategeninfosave = resAM.data;
            yield put({ type: CreateGenInfoActionTypes.SUCCESS, payload: creategeninfosave });
        } else if (userType === 'EM') {
            const resEM = yield call(axios, `/api/itr/checklist/em-approve-relevance/${tennantnameValue}`, {
                method: 'put',
                baseURL: `${CommonConfig.dev.baseUrl1}`,
                data: data,
                headers: {
                    Authorization: bearerToken,
                },
            });
            const creategeninfosave = resEM.data;
            yield put({ type: CreateGenInfoActionTypes.SUCCESS, payload: creategeninfosave });
        } else if (userType === 'ITeC Team') {
            const crcres = yield call(axios, `/api/itr/checklist/crc-submit-relevance/${imcNameSelected}`, {
                method: 'put',
                baseURL: `${CommonConfig.dev.baseUrl1}`,
                data: data,
                headers: {
                    Authorization: bearerToken,
                },
            });
            const creategeninfosumbit = crcres.data;
            yield put({ type: CreateGenInfoRequestSubmitActionTypes.SUCCESS, payload: creategeninfosumbit });
        }
    } catch (e) {
        const errorMessage = e.response.data.message;
        yield put({ type: CreateGenInfoRequestSubmitActionTypes.FAILED, error: errorMessage });
    }
}

function* watchCreateGenInfoSaveRequest() {
    yield takeEvery(CreateGenInfoActionTypes.REQUEST, handleGenInfoRequestSave);
    yield takeEvery(CreateGenInfoRequestSubmitActionTypes.REQUEST, handleGenInfoRequestSubmit);
}

export function* createGenInfoSaveSaga() {
    yield all([watchCreateGenInfoSaveRequest()]);
}
